{
  "save": "Enregistrer",
  "cancel": "Annuler",
  "edit": "Modifier",
  "delete": "Supprimer",
  "create": "Créer",
  "apply": "Appliquer",
  "preview": "Aperçu",
  "label": "Étiquette",
  "confirm": "Confirmer",
  "close": "Fermer",
  "accept": "Accepter",
  "loading": "Chargement...",
  "error": "Erreur",
  "success": "Succès",
  "changesSaved": "Modifications enregistrées avec succès",
  "errorOccurred": "Une erreur est survenue",
  "name": "Nom",
  "email": "Email",
  "password": "Mot de passe",
  "description": "Description",
  "title": "Titre",
  "image": "Image",
  "file": "Fichier",
  "required": "Ce champ est requis",
  "invalidEmail": "Adresse email invalide",
  "invalidPassword": "Mot de passe invalide",
  "facebook": "Facebook",
  "instagram": "Instagram",
  "linkedin": "LinkedIn",
  "reddit": "Reddit",
  "tiktok": "TikTok",
  "x": "X (Twitter)",
  "youtube": "YouTube",
  "website": "Site web",
  "workspaceInviteAccept": {
    "brandAria": "Accueil Socialize",
    "eyebrow": "Invitation d'espace",
    "title": "Rejoindre {workspace} dans Socialize",
    "description": "Connectez-vous ou créez un compte avec l'email invité pour accepter cette invitation.",
    "signedInDescription": "Nous acceptons votre invitation et préparons votre accès à l'espace.",
    "acceptingTitle": "Acceptation de l'invitation",
    "acceptingDescription": "Nous ajoutons cet espace à votre compte et actualisons vos accès.",
    "acceptedTitle": "Invitation acceptée",
    "acceptedDescription": "Cet espace est déjà connecté à votre compte.",
    "cancelledTitle": "Invitation indisponible",
    "cancelledDescription": "Cette invitation a été annulée par un gestionnaire de l'espace.",
    "mismatchTitle": "Utilisez l'email invité",
    "mismatchDescription": "Cette invitation peut seulement être acceptée par l'adresse email affichée ci-dessous. Connectez-vous avec ce compte, puis ouvrez l'invitation à nouveau.",
    "notFoundTitle": "Invitation introuvable",
    "notFoundDescription": "Ce lien d'invitation est invalide ou n'est plus disponible.",
    "workspace": "Espace",
    "email": "Email invité",
    "role": "Rôle",
    "signIn": "Se connecter",
    "createAccount": "Créer un compte",
    "acceptInvite": "Réessayer",
    "openApp": "Ouvrir l'app"
  },
  "organizationInviteAccept": {
    "brandAria": "Accueil Socialize",
    "eyebrow": "Invitation d'organisation",
    "title": "Rejoindre {organization} dans Socialize",
    "description": "Connectez-vous ou créez un compte avec l'email invité pour accepter cette invitation d'organisation.",
    "signedInDescription": "Nous acceptons votre invitation et préparons votre accès à l'organisation.",
    "acceptingTitle": "Acceptation de l'invitation",
    "acceptingDescription": "Nous ajoutons cette organisation à votre compte et actualisons vos accès.",
    "acceptedTitle": "Invitation acceptée",
    "acceptedDescription": "Cette organisation est déjà connectée à votre compte.",
    "cancelledTitle": "Invitation indisponible",
    "cancelledDescription": "Cette invitation a été annulée par un gestionnaire de l'organisation.",
    "mismatchTitle": "Utilisez l'email invité",
    "mismatchDescription": "Cette invitation peut seulement être acceptée par l'adresse email affichée ci-dessous. Connectez-vous avec ce compte, puis ouvrez l'invitation à nouveau.",
    "notFoundTitle": "Invitation introuvable",
    "notFoundDescription": "Ce lien d'invitation est invalide ou n'est plus disponible.",
    "organization": "Organisation",
    "email": "Email invité",
    "role": "Rôle",
    "signIn": "Se connecter",
    "createAccount": "Créer un compte",
    "acceptInvite": "Réessayer",
    "openApp": "Ouvrir l'app"
  },
  "public": {
    "nav": {
      "product": "Produit",
      "pricing": "Tarifs",
      "resources": "Ressources",
      "blogs": "Articles",
      "guides": "Guides",
      "ariaLabel": "Navigation du site public",
      "language": "Langue",
      "openApp": "Ouvrir l'app",
      "login": "Connexion"
    },
    "landing": {
      "meta": {
        "title": "BrioSocialize — Révision et approbation de contenu social",
        "description": "Essayez BrioSocialize pour centraliser la révision de contenu social, les versions, les approbations client et la remise pour publication dans un seul workflow."
      },
      "hero": {
        "eyebrow": "Approbations client sans relance",
        "title": "Faites approuver le contenu social avant que la prochaine échéance glisse.",
        "description": "Arrêtez de fouiller dans les liens de fichiers, emails, chats et tableurs. BrioSocialize donne aux agences et aux équipes de contenu un workflow ciblé pour les révisions, les versions, les approbations et la remise pour publication.",
        "primaryAction": "Essayer l'app",
        "secondaryAction": "Essayer l'app",
        "ctaNote": "Commencez avec votre prochaine révision client. Aucune migration de publication requise."
      },
      "proof": {
        "reviews": {
          "value": "1 endroit",
          "label": "pour chaque révision"
        },
        "handoff": {
          "value": "0 flou",
          "label": "à la remise publication"
        },
        "traceability": {
          "value": "Contexte complet",
          "label": "pour chaque approbation"
        }
      },
      "mockup": {
        "title": "File de révision",
        "badge": "Workflow actif",
        "reel": {
          "title": "Reel lancement mai",
          "meta": "Instagram · Révision client",
          "status": "À approuver"
        },
        "launch": {
          "title": "Annonce produit",
          "meta": "LinkedIn · Révision interne",
          "status": "Retours notés"
        },
        "newsletter": {
          "title": "Infolettre juin",
          "meta": "Email · Prêt pour remise",
          "status": "Approuvé"
        },
        "approvalLabel": "Dernière décision",
        "approvalValue": "La version approuvée est claire, traçable et prête à planifier."
      },
      "pillars": {
        "singleSource": {
          "eyebrow": "Moins de suivis",
          "title": "Chaque commentaire, version, décision et échéance reste attaché au contenu."
        },
        "collaboration": {
          "eyebrow": "Collaboration qui avance",
          "title": "Donnez aux équipes d'agence, aux fournisseurs et aux approbateurs client un endroit évident pour réviser et approuver."
        },
        "ownership": {
          "eyebrow": "Gardez le contrôle de vos données",
          "title": "Gardez les fichiers client là où ils doivent être pendant que BrioSocialize organise le workflow autour d'eux."
        }
      },
      "focus": {
        "eyebrow": "Pourquoi l'essayer",
        "title": "Le moyen le plus rapide de sentir la différence est de passer une vraie approbation dans BrioSocialize.",
        "workspaces": {
          "label": "Espaces",
          "description": "Gardez chaque marque ou entreprise dans un espace de révision propre"
        },
        "campaigns": {
          "label": "Campagnes",
          "description": "Regroupez le travail autour des échéances, approbations et objectifs de livraison"
        },
        "contentItems": {
          "label": "Contenus",
          "description": "Rendez chaque post, asset et approbation facile à retrouver"
        }
      },
      "finalCta": {
        "eyebrow": "Essayez-le sur votre prochaine approbation",
        "title": "Vous avez déjà du contenu qui attend des retours. Mettez le prochain dans BrioSocialize.",
        "description": "Ajoutez une révision client dans un espace et voyez comme c'est plus simple quand les retours, versions et approbations restent ensemble."
      }
    },
    "product": {
      "meta": {
        "title": "Produit BrioSocialize — Planifier, réviser et approuver du contenu",
        "description": "BrioSocialize garde les contenus, les assets, les versions, les commentaires, les décisions d'approbation et la remise pour publication dans un seul espace."
      },
      "eyebrow": "Produit",
      "title": "L'approbation de contenu social, organisée autour du travail lui-même.",
      "description": "BrioSocialize garde les contenus, les assets, les versions, les commentaires, les décisions d'approbation et la remise pour publication dans un seul espace afin que les équipes n'aient plus à coordonner les révisions dans des outils dispersés.",
      "featureEyebrow": "Fonctionnalités",
      "featureTitle": "Suivez le travail de la demande à l'approbation."
    },
    "features": {
      "content-planning": {
        "title": "Planification de contenu",
        "description": "Structurez le travail à venir autour des clients, campagnes, canaux, responsables et échéances.",
        "detailTitle": "Planifiez le contenu social avant la révision.",
        "detailDescription": "Créez des contenus avec le contexte dont les réviseurs ont besoin : texte, canaux, dates, campagnes et notes de production.",
        "bullets": [
          "Organisez le travail par espace, client et campagne.",
          "Suivez les dates prévues, les canaux et la préparation à la révision.",
          "Gardez la demande, le brief et le contenu à réviser ensemble."
        ]
      },
      "asset-revisions": {
        "title": "Versions d'assets",
        "description": "Gardez les fichiers et les versions traçables sans obliger les équipes à changer de stockage.",
        "detailTitle": "Rendez la dernière version évidente.",
        "detailDescription": "Liez les assets créatifs, conservez l'historique des versions et gardez les retours connectés à la version révisée.",
        "bullets": [
          "Ajoutez images, vidéos, documents et références de fichiers.",
          "Préservez les anciennes versions au lieu d'effacer le contexte.",
          "Aidez les réviseurs à savoir quelle version est courante."
        ]
      },
      "comment-threads": {
        "title": "Fils de commentaires",
        "description": "Gardez les retours attachés au contenu plutôt que dispersés dans les chats et emails.",
        "detailTitle": "Placez les conversations de révision avec le travail.",
        "detailDescription": "Centralisez les retours, questions, notes internes et commentaires client autour du contenu.",
        "bullets": [
          "Gardez la discussion liée au bon contenu ou à la bonne version.",
          "Séparez les commentaires de workflow des décisions d'approbation.",
          "Réduisez les suivis en gardant le contexte visible."
        ]
      },
      "approval-workflows": {
        "title": "Workflows d'approbation",
        "description": "Enregistrez des décisions d’approbation claires avant la remise finale pour publication.",
        "detailTitle": "Transformez la révision en décision claire.",
        "detailDescription": "Prenez en charge des approbations requises, optionnelles ou à plusieurs étapes pour savoir quand le contenu est vraiment approuvé.",
        "bullets": [
          "Suivez qui a approuvé et quand.",
          "Soutenez la révision interne avant l'approbation client.",
          "Gardez l'état d'approbation séparé des retours informels."
        ]
      },
      "client-review": {
        "title": "Révision client",
        "description": "Donnez aux approbateurs externes une manière ciblée de réviser sans accès complet à l'espace.",
        "detailTitle": "Rendez la révision client plus simple à terminer.",
        "detailDescription": "Partagez un accès de révision ciblé pour que les clients puissent commenter et approuver le contenu qui les concerne.",
        "bullets": [
          "Gardez les clients concentrés sur le contenu à réviser.",
          "Évitez d'exposer les détails internes de l'espace.",
          "Réduisez les allers-retours avec une surface d'approbation claire."
        ]
      },
      "review-queues": {
        "title": "Files de révision",
        "description": "Montrez ce qui demande attention, ce qui bloque et ce qui peut avancer.",
        "detailTitle": "Sachez quoi réviser ensuite.",
        "detailDescription": "Faites ressortir les approbations en attente, le travail en retard et les contenus qui attendent un retour.",
        "bullets": [
          "Suivez les contenus en attente de révision interne ou client.",
          "Repérez les blocages avant que les échéances glissent.",
          "Gardez le travail d'approbation visible dans l'espace."
        ]
      },
      "audit-trail": {
        "title": "Historique d'audit",
        "description": "Préservez l'historique des uploads, commentaires, changements de statut et approbations.",
        "detailTitle": "Gardez un historique fiable.",
        "detailDescription": "BrioSocialize garde l'historique du workflow attaché au contenu afin que les décisions et versions restent traçables.",
        "bullets": [
          "Consultez les changements de statut et l'historique d'approbation.",
          "Préservez le contexte des versions après les changements.",
          "Vérifiez plus facilement les décisions de remise."
        ]
      },
      "workspace-access": {
        "title": "Accès par espace",
        "description": "Séparez membres de l'organisation, collaborateurs, clients et approbateurs.",
        "detailTitle": "Donnez le bon périmètre aux bonnes personnes.",
        "detailDescription": "Utilisez les espaces comme limite de marque ou de client tout en séparant l'accès organisation, les collaborateurs et les réviseurs externes.",
        "bullets": [
          "Gardez chaque client ou marque dans son propre espace.",
          "Invitez des collaborateurs externes sans les ajouter à l'organisation.",
          "Préservez le périmètre des données de révision par espace."
        ]
      },
      "team-collaboration": {
        "title": "Collaboration d'équipe",
        "description": "Coordonnez agences, producteurs, fournisseurs et approbateurs client dans un même workflow.",
        "detailTitle": "Rassemblez tous les réviseurs dans un même workflow.",
        "detailDescription": "Aidez les équipes internes, partenaires de production et clients à travailler depuis le même état de révision sans perdre la propriété de leur partie du processus.",
        "bullets": [
          "Coordonnez contributeurs internes et externes.",
          "Gardez la révision d'équipe et la révision client connectées.",
          "Rendez les responsabilités et prochaines étapes plus visibles."
        ]
      }
    },
    "pricing": {
      "meta": {
        "title": "Tarifs BrioSocialize — Forfaits pour pigistes, agences et équipes",
        "description": "Tarifs BrioSocialize pour freelances, agences et équipes qui gèrent les approbations de contenu social avec leurs clients."
      },
      "eyebrow": "Tarifs",
      "title": "Commencez gratuitement. Passez au niveau supérieur quand les approbations deviennent du travail client.",
      "description": "Choisissez le forfait adapté à votre volume de révision. Chaque niveau garde contenus, retours, versions et approbations dans un seul workflow.",
      "bestValue": "Meilleure offre",
      "includedLabel": "Inclus",
      "limitsLabel": "Limites",
      "tiers": {
        "free": {
          "name": "Free",
          "description": "Pour essayer BrioSocialize sur un vrai workflow d'approbation.",
          "price": "0 $",
          "priceNote": "pour toujours",
          "action": "Essayer l'app",
          "features": [
            "Contenus avec texte et liens d'assets",
            "Commentaires de base et historique de révision",
            "Un workflow d'approbation",
            "Vue de révision prête pour le client",
            "Notes de remise prêtes à envoyer"
          ],
          "limits": ["1 espace", "3 contenus actifs", "2 membres d'équipe", "1 réviseur externe"]
        },
        "freelance": {
          "name": "Freelance",
          "description": "Pour les indépendants qui gèrent des révisions client récurrentes.",
          "price": "19 $",
          "priceNote": "par mois",
          "action": "Choisir Freelance",
          "features": [
            "Tout le forfait Free",
            "Suivi des versions pour assets et texte",
            "Workflow d'approbation client réutilisable",
            "File de révision pour le travail actif",
            "Historique d'activité des approbations"
          ],
          "limits": ["3 espaces", "25 contenus actifs", "5 membres d'équipe", "10 réviseurs externes"]
        },
        "agency": {
          "name": "Agency",
          "description": "Pour les agences qui veulent des opérations d'approbation client répétables.",
          "price": "79 $",
          "priceNote": "par mois",
          "action": "Choisir Agency",
          "features": [
            "Tout le forfait Freelance",
            "Gestion de plusieurs espaces client",
            "Révision interne avant approbation client",
            "Workflows d'approbation multi-étapes",
            "Files prioritaires et historique d'audit"
          ],
          "limits": ["15 espaces", "250 contenus actifs", "25 membres d'équipe", "Réviseurs externes illimités"]
        },
        "enterprise": {
          "name": "Enterprise",
          "description": "Pour les grandes organisations avec des besoins de gouvernance et d'accès.",
          "price": "Sur mesure",
          "priceNote": "forfait adapté",
          "action": "Choisir Enterprise",
          "features": [
            "Tout le forfait Agency",
            "Contrôles d'accès au niveau organisation",
            "Configuration avancée des approbations",
            "Accompagnement dédié à l'onboarding",
            "Limites personnalisées d'usage et d'espaces"
          ],
          "limits": [
            "Espaces illimités",
            "Contenus actifs illimités",
            "Limites de membres personnalisées",
            "Limites de réviseurs personnalisées"
          ]
        }
      }
    },
    "blogs": {
      "meta": {
        "title": "Articles BrioSocialize — Révision et approbation de contenu",
        "description": "Articles pratiques sur les workflows de révision, l'approbation client, le suivi des versions et la remise pour publication."
      },
      "eyebrow": "Articles",
      "title": "Notes pratiques sur les workflows de révision de contenu.",
      "description": "Des articles pratiques de Brio Conception inc. sur les approbations, la révision client, le suivi des versions et la remise pour publication."
    },
    "guides": {
      "meta": {
        "title": "Guides BrioSocialize — Méthodes pratiques pour vos contenus",
        "description": "Guides réutilisables pour l'intake de contenu, les cycles de révision, les décisions d'approbation et la préparation à la livraison."
      },
      "eyebrow": "Guides",
      "title": "Guides réutilisables pour gérer les révisions et les approbations.",
      "description": "Des méthodes détaillées pour l’entrée de contenu, les cycles de révision, les décisions, la gestion des versions et la préparation à publier."
    },
    "terms": {
      "meta": {
        "title": "Conditions d’utilisation de BrioSocialize",
        "description": "Conditions d’utilisation de la plateforme BrioSocialize pour la révision, l’approbation et la remise de contenu de médias sociaux."
      },
      "eyebrow": "Légal",
      "title": "Conditions d’utilisation",
      "description": "Ces conditions régissent l’accès à BrioSocialize, une plateforme professionnelle de planification, révision, approbation et remise de contenu destiné aux médias sociaux.",
      "effectiveDate": "Date d’entrée en vigueur : 18 juin 2026",
      "sections": [
        {
          "title": "1. Acceptation des conditions",
          "paragraphs": [
            "En créant un compte, en acceptant une invitation, en vous connectant ou en utilisant BrioSocialize, vous acceptez les présentes Conditions d’utilisation. Si vous utilisez BrioSocialize pour une organisation, un client, une agence ou toute autre entité, vous déclarez être autorisé à lier cette entité et ses utilisateurs autorisés.",
            "Si vous n’acceptez pas ces conditions, vous ne devez pas accéder à BrioSocialize ni l’utiliser."
          ]
        },
        {
          "title": "2. Le service",
          "paragraphs": [
            "BrioSocialize n’est pas un réseau social public. Il s’agit d’une application SaaS organisée par espaces de travail pour aider les équipes internes, les fournisseurs et les approbateurs clients à coordonner du contenu de médias sociaux avant publication.",
            "Le service peut comprendre des organisations, des espaces, des canaux, du contexte calendrier, des contenus, des références d’actifs, des commentaires, des décisions d’approbation, des notifications, la connexion sociale, des connexions fournisseurs et des outils de remise pour publication."
          ]
        },
        {
          "title": "3. Comptes et utilisateurs autorisés",
          "paragraphs": [
            "Vous devez fournir des renseignements de compte exacts, protéger vos identifiants et informer rapidement BrioSocialize de tout soupçon d’accès non autorisé. Vous êtes responsable des activités effectuées avec votre compte, sauf dans la mesure où elles découlent d’un manquement de BrioSocialize aux présentes conditions.",
            "Les administrateurs sont responsables des invitations, de l’attribution des rôles, du contrôle des accès aux espaces, du retrait des utilisateurs qui n’ont plus besoin d’accès et de la vérification que les réviseurs externes sont autorisés à consulter le contenu partagé avec eux."
          ]
        },
        {
          "title": "4. Contenu client",
          "paragraphs": [
            "Le contenu client désigne le contenu, les textes, commentaires, approbations, fichiers, liens, métadonnées, paramètres d’espace, paramètres de canal et autres éléments soumis à BrioSocialize ou traités par BrioSocialize par les utilisateurs. Entre vous et BrioSocialize, vous conservez la propriété du contenu client.",
            "Vous accordez à BrioSocialize une licence limitée, mondiale et non exclusive lui permettant d’héberger, traiter, transmettre, afficher, reproduire et créer des copies techniques du contenu client uniquement dans la mesure nécessaire pour fournir, sécuriser, maintenir, soutenir et améliorer le service."
          ],
          "items": [
            "Vous êtes responsable de détenir tous les droits, autorisations et fondements juridiques nécessaires pour soumettre du contenu client.",
            "Vous ne devez pas soumettre de contenu illégal, contrefaisant, trompeur, diffamatoire, harcelant, malveillant ou conçu pour compromettre des systèmes.",
            "BrioSocialize peut supprimer ou restreindre l’accès à du contenu lorsque cela est raisonnablement nécessaire pour respecter la loi, protéger le service ou répondre à une préoccupation crédible liée aux droits ou à la sécurité."
          ]
        },
        {
          "title": "5. Utilisation acceptable",
          "paragraphs": [
            "Vous devez utiliser BrioSocialize uniquement à des fins professionnelles et commerciales licites. Vous ne devez pas détourner le service ni nuire à son fonctionnement."
          ],
          "items": [
            "Ne tentez pas de contourner l’authentification, les autorisations, les limites de débit, les contrôles de sécurité ou les limites entre espaces.",
            "Ne faites pas d’ingénierie inverse, d’extraction massive, de surcharge, de sondage ou de perturbation du service, sauf autorisation écrite expresse.",
            "N’utilisez pas BrioSocialize pour envoyer du pourriel, des logiciels malveillants, des communications abusives ou du contenu qui viole les droits d’autrui.",
            "Ne partagez pas de jetons d’accès, d’identifiants fournisseurs ou d’informations confidentielles d’un espace avec des personnes non autorisées."
          ]
        },
        {
          "title": "6. Services tiers et plateformes sociales",
          "paragraphs": [
            "BrioSocialize peut se connecter à des plateformes tierces ou aider à organiser du travail lié à des réseaux sociaux, fournisseurs d’identité, calendriers, services courriel, services de stockage, outils d’analyse, services d’hébergement et fournisseurs de paiement. Les services tiers sont régis par leurs propres conditions et politiques.",
            "Vous êtes responsable de respecter les règles de toute plateforme sociale ou de tout service tiers que vous connectez, y compris les conditions de plateforme, politiques de contenu, règles publicitaires, limites d’API, permissions et exigences de révision. BrioSocialize n’est pas responsable des pannes de tiers, décisions de plateformes, contenus retirés, publications refusées ou changements d’API de tiers."
          ]
        },
        {
          "title": "7. Frais et abonnements",
          "paragraphs": [
            "Certaines fonctionnalités peuvent être offertes gratuitement et d’autres peuvent nécessiter un abonnement payant. Les prix, limites d’utilisation, taxes, modalités de renouvellement et règles d’annulation seront indiqués dans la commande, le paiement, la facture ou la documentation de forfait applicable.",
            "Sauf indication contraire dans une entente écrite distincte, les frais ne sont pas remboursables, sauf lorsque la loi l’exige ou lorsque cela est expressément indiqué au moment de l’achat."
          ]
        },
        {
          "title": "8. Confidentialité et sécurité",
          "paragraphs": [
            "Chaque partie peut recevoir des renseignements confidentiels de l’autre. La partie réceptrice doit prendre des mesures raisonnables pour les protéger et ne peut les utiliser que pour exécuter ses obligations ou exercer ses droits au titre des présentes conditions.",
            "BrioSocialize utilise des mesures administratives, techniques et organisationnelles destinées à protéger le service. Aucun service en ligne ne peut garantir une sécurité absolue. Vous demeurez responsable de configurer soigneusement les accès et de protéger les terminaux, identifiants et comptes connectés."
          ]
        },
        {
          "title": "9. Propriété intellectuelle",
          "paragraphs": [
            "BrioSocialize et ses concédants conservent tous les droits sur le service, les logiciels, interfaces, workflows, designs, documentations, marques de commerce et technologies connexes. Les présentes conditions ne vous transfèrent aucun droit de propriété sur la technologie BrioSocialize.",
            "Les commentaires, suggestions ou idées que vous fournissez peuvent être utilisés par BrioSocialize sans restriction ni compensation, pourvu que BrioSocialize ne divulgue pas vos renseignements confidentiels en le faisant."
          ]
        },
        {
          "title": "10. Fonctionnalités bêta et disponibilité",
          "paragraphs": [
            "BrioSocialize peut offrir des fonctionnalités bêta, préversion, expérimentales ou en accès anticipé. Ces fonctionnalités peuvent être modifiées, suspendues ou retirées en tout temps et peuvent être soumises à des limites additionnelles.",
            "BrioSocialize vise à fournir un service fiable, mais la disponibilité peut être touchée par la maintenance, les mises à jour, les travaux de sécurité, les dépendances tierces, les conditions Internet ou des événements hors de son contrôle raisonnable."
          ]
        },
        {
          "title": "11. Suspension et résiliation",
          "paragraphs": [
            "Vous pouvez cesser d’utiliser BrioSocialize en tout temps. BrioSocialize peut suspendre ou résilier l’accès si vous violez substantiellement les présentes conditions, créez un risque de sécurité ou juridique, omettez de payer des frais requis ou utilisez le service d’une manière susceptible de nuire à BrioSocialize, aux utilisateurs ou à des tiers.",
            "Après la résiliation, BrioSocialize peut conserver, supprimer ou exporter le contenu client conformément à la Politique de confidentialité, à toute commande ou entente écrite applicable et aux exigences légales de conservation."
          ]
        },
        {
          "title": "12. Exclusions de garantie",
          "paragraphs": [
            "Dans la mesure maximale permise par la loi, BrioSocialize est fourni tel quel et selon disponibilité. BrioSocialize exclut les garanties implicites de qualité marchande, d’adaptation à un usage particulier, d’absence de contrefaçon, de fonctionnement ininterrompu et de fonctionnement sans erreur.",
            "BrioSocialize ne fournit pas de conseils juridiques, réglementaires, publicitaires, professionnels ou de conformité aux plateformes. Vous êtes responsable de réviser le contenu, les approbations, les décisions de publication et la conformité juridique avant publication."
          ]
        },
        {
          "title": "13. Limitation de responsabilité",
          "paragraphs": [
            "Dans la mesure maximale permise par la loi, BrioSocialize ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs, exemplaires ou punitifs, ni des pertes de profits, revenus, clientèle, données, interruption d’activité ou services de remplacement.",
            "Dans la mesure maximale permise par la loi, la responsabilité totale de BrioSocialize découlant du service ou des présentes conditions ne dépassera pas les montants que vous avez payés à BrioSocialize pour le service pendant les douze mois précédant l’événement donnant lieu à la responsabilité, ou 100 $ CA si aucun montant n’a été payé."
          ]
        },
        {
          "title": "14. Indemnisation",
          "paragraphs": [
            "Vous défendrez, indemniserez et dégagerez BrioSocialize de toute réclamation, dommage, responsabilité, coût et dépense découlant du contenu client, de votre utilisation du service, de votre violation des présentes conditions, de votre violation de la loi ou de votre atteinte aux droits d’un tiers."
          ]
        },
        {
          "title": "15. Droit applicable et différends",
          "paragraphs": [
            "Sauf indication contraire dans une entente écrite distincte, les présentes conditions sont régies par les lois du Canada et les lois de la province ou du territoire canadien où l’exploitant de BrioSocialize a son principal établissement, sans égard aux règles de conflit de lois.",
            "Les parties tenteront d’abord de résoudre les différends de bonne foi. Si un différend ne peut être résolu à l’amiable, il devra être porté devant les tribunaux situés dans cette province ou ce territoire, sauf si la loi applicable vous accorde un droit impératif d’intenter une réclamation ailleurs."
          ]
        },
        {
          "title": "16. Modifications des conditions",
          "paragraphs": [
            "BrioSocialize peut mettre à jour les présentes conditions de temps à autre. Les changements importants seront communiqués par des moyens raisonnables, par exemple par publication d’une version mise à jour, avis dans le produit ou courriel. L’utilisation continue après la date d’entrée en vigueur des conditions mises à jour signifie que vous les acceptez."
          ]
        },
        {
          "title": "17. Contact",
          "paragraphs": [
            "BrioSocialize est développé et exploité par Brio Conception inc., 6927, rue Marie-Drouet, Trois-Rivières, Québec, G8Y 7H8, Canada. Les questions concernant ces conditions peuvent être transmises à Brio Conception inc. par le canal de contact disponible dans BrioSocialize ou par téléphone au +1 581 999-7540."
          ]
        }
      ]
    },
    "privacy": {
      "meta": {
        "title": "Politique de confidentialité de BrioSocialize",
        "description": "Politique de confidentialité expliquant comment BrioSocialize collecte, utilise, communique, conserve et protège les renseignements personnels."
      },
      "eyebrow": "Légal",
      "title": "Politique de confidentialité",
      "description": "Cette Politique de confidentialité explique comment BrioSocialize traite les renseignements personnels lorsque des personnes visitent le site public, créent un compte, rejoignent des espaces, utilisent des intégrations ou interagissent avec le service.",
      "effectiveDate": "Date d’entrée en vigueur : 18 juin 2026",
      "sections": [
        {
          "title": "1. Portée",
          "paragraphs": [
            "La présente politique s’applique aux sites web, à l’application, aux pages publiques, aux flux d’authentification, aux interactions de soutien et aux services connexes de BrioSocialize. Elle ne s’applique pas aux plateformes tierces, réseaux sociaux, fournisseurs d’identité, calendriers, processeurs de paiement ou autres services régis par leurs propres politiques de confidentialité.",
            "BrioSocialize est conçu pour un usage professionnel et commercial. Il ne s’adresse pas aux enfants de moins de 13 ans, et les utilisateurs ne doivent pas inviter d’enfants à utiliser le service sauf si un fondement juridique et tous les consentements requis sont en place."
          ]
        },
        {
          "title": "2. Renseignements personnels collectés",
          "paragraphs": [
            "Les renseignements que nous collectons dépendent de votre utilisation de BrioSocialize et de la configuration de votre organisation."
          ],
          "items": [
            "Renseignements de compte, comme le nom, l’adresse courriel, les données d’authentification du mot de passe, les paramètres de profil, la langue et l’état de vérification.",
            "Renseignements d’organisation et d’espace, comme les rôles, adhésions, invitations, permissions, noms d’espaces, paramètres de canaux, historique d’audit et registres d’activité.",
            "Renseignements de contenu et de collaboration, comme les contenus, commentaires, décisions d’approbation, métadonnées d’actifs, références de fichiers, dates planifiées, détails de remise pour publication et préférences de notification.",
            "Renseignements d’intégration, comme les identifiants de connexion sociale, métadonnées de comptes fournisseurs, identifiants de canaux, métadonnées de sources calendrier, jetons d’accès, jetons d’actualisation, portées de permission et état de connexion lorsqu’une intégration est activée.",
            "Renseignements techniques, comme l’adresse IP, les informations d’appareil et de navigateur, journaux, événements de diagnostic, événements de sécurité, rapports d’erreur, témoins, identifiants de session et emplacement approximatif dérivé de l’information réseau.",
            "Renseignements de soutien et de communication, comme les messages, rapports de rétroaction, captures d’écran volontairement soumises et correspondance avec BrioSocialize."
          ]
        },
        {
          "title": "3. Utilisation des renseignements personnels",
          "paragraphs": [
            "BrioSocialize utilise les renseignements personnels à des fins nécessaires ou raisonnablement attendues dans l’exploitation d’un service professionnel de workflow."
          ],
          "items": [
            "Créer des comptes, authentifier les utilisateurs, maintenir les sessions, vérifier les adresses courriel et récupérer les mots de passe.",
            "Fournir les organisations, espaces, révisions de contenu, commentaires, approbations, notifications, références d’actifs, contexte calendrier et workflows de remise pour publication.",
            "Connecter et maintenir les intégrations que les utilisateurs ou administrateurs choisissent d’activer.",
            "Sécuriser le service, prévenir les abus, enquêter sur les activités suspectes, corriger les erreurs et appliquer les conditions et permissions.",
            "Communiquer au sujet des comptes, invitations, activités de workflow, mises à jour du service, enjeux de sécurité, demandes de soutien et questions administratives.",
            "Analyser la performance du service, améliorer la qualité du produit, développer des fonctionnalités et comprendre l’utilisation d’une manière appropriée à la nature du service.",
            "Respecter les obligations légales, préserver les droits, résoudre les différends et répondre aux demandes licites."
          ]
        },
        {
          "title": "4. Fondements juridiques et consentement",
          "paragraphs": [
            "Selon votre lieu de résidence, BrioSocialize peut s’appuyer sur le consentement, l’exécution d’un contrat, des intérêts légitimes, des obligations légales ou un autre fondement licite pour collecter, utiliser et communiquer des renseignements personnels.",
            "Lorsque le consentement est requis, vous pouvez le retirer en tout temps, sous réserve des limites légales, contractuelles, de sécurité et techniques. Le retrait peut empêcher BrioSocialize de fournir les fonctionnalités qui dépendent de ces renseignements ou de cette intégration."
          ]
        },
        {
          "title": "5. Communication des renseignements",
          "paragraphs": [
            "BrioSocialize ne vend pas les renseignements personnels. Nous communiquons des renseignements personnels uniquement lorsque cela est nécessaire pour fournir et exploiter le service, selon les instructions des utilisateurs ou administrateurs, ou lorsque la loi le permet ou l’exige."
          ],
          "items": [
            "Au sein des organisations et espaces selon les rôles, permissions, invitations, commentaires, approbations et accès configurés.",
            "À des fournisseurs de services qui hébergent l’infrastructure, stockent les données, envoient des courriels, traitent les paiements, surveillent la fiabilité, fournissent de l’analyse, soutiennent la sécurité ou aident à exploiter le service.",
            "À des plateformes tierces et intégrations lorsque des utilisateurs ou administrateurs connectent des comptes ou demandent des fonctionnalités d’intégration.",
            "Pour respecter la loi, une procédure judiciaire, une demande réglementaire, une enquête de sécurité, l’application des conditions ou la protection des droits, de la sécurité et des biens.",
            "Dans le cadre d’une fusion, acquisition, financement, restructuration ou vente d’actifs, sous réserve de protections appropriées de confidentialité et de continuité."
          ]
        },
        {
          "title": "6. Traitement international",
          "paragraphs": [
            "Les renseignements personnels peuvent être traités au Canada, aux États-Unis et dans d’autres pays où BrioSocialize ou ses fournisseurs de services exercent leurs activités. Ces pays peuvent avoir des lois sur la protection de la vie privée différentes de celles de votre province, État ou pays.",
            "Lorsque requis, BrioSocialize utilise des mesures contractuelles, organisationnelles et techniques destinées à protéger les renseignements personnels lors du traitement transfrontalier."
          ]
        },
        {
          "title": "7. Conservation",
          "paragraphs": [
            "BrioSocialize conserve les renseignements personnels aussi longtemps que raisonnablement nécessaire pour fournir le service, maintenir des registres, respecter les obligations légales, résoudre les différends, faire appliquer les ententes, protéger la sécurité et soutenir des besoins commerciaux légitimes.",
            "Les périodes de conservation varient selon le type de données. Les données de compte et d’espace peuvent demeurer tant qu’un compte, une organisation ou un espace est actif. Les sauvegardes et journaux peuvent subsister pendant une période limitée après la suppression. Certains renseignements peuvent être conservés lorsque cela est requis à des fins légales, de sécurité, d’audit, financières ou de différend."
          ]
        },
        {
          "title": "8. Sécurité",
          "paragraphs": [
            "BrioSocialize utilise des mesures administratives, techniques et organisationnelles raisonnables destinées à protéger les renseignements personnels contre l’accès, l’utilisation, la communication, la modification et la destruction non autorisés.",
            "Aucun système n’est parfaitement sécurisé. Les utilisateurs et administrateurs doivent protéger les identifiants, configurer soigneusement les accès aux espaces, retirer les utilisateurs inactifs et éviter d’inscrire des renseignements sensibles non nécessaires dans les contenus ou commentaires."
          ]
        },
        {
          "title": "9. Témoins et technologies similaires",
          "paragraphs": [
            "BrioSocialize peut utiliser des témoins, le stockage local, le stockage de session et des technologies similaires pour garder les utilisateurs connectés, mémoriser des préférences comme la langue, soutenir la sécurité, mesurer la performance et exploiter le site public et l’application.",
            "Les paramètres du navigateur peuvent permettre de bloquer ou supprimer certaines technologies, mais cela peut affecter l’authentification, les préférences ou les fonctionnalités de l’application."
          ]
        },
        {
          "title": "10. Vos droits relatifs à la vie privée",
          "paragraphs": [
            "Selon votre lieu de résidence, vous pouvez avoir le droit d’accéder à certains renseignements personnels, de les corriger, supprimer, exporter, restreindre, de vous opposer à leur traitement ou de retirer votre consentement. Vous pouvez aussi avoir le droit de porter plainte auprès d’une autorité de protection de la vie privée.",
            "Pour protéger les utilisateurs et organisations, BrioSocialize peut devoir vérifier votre identité, votre autorité, la propriété du compte et votre rôle dans l’espace avant de donner suite à une demande. Certaines demandes peuvent être limitées par des obligations légales, des besoins de sécurité, les renseignements confidentiels d’autrui ou des registres devant être conservés."
          ]
        },
        {
          "title": "11. Suppression de compte et de données d’application",
          "paragraphs": [
            "Les renseignements sur la suppression des données de compte ou d’application sont disponibles à /privacy/delete. Les administrateurs peuvent aussi retirer l’accès à un espace ou supprimer des espaces lorsque le produit le permet.",
            "La suppression ne retire pas nécessairement immédiatement les renseignements des sauvegardes, journaux de sécurité, registres financiers, obligations de conservation juridique, registres d’audit ou plateformes tierces ayant reçu des renseignements par intégration."
          ]
        },
        {
          "title": "12. Modifications de cette politique",
          "paragraphs": [
            "BrioSocialize peut mettre à jour la présente Politique de confidentialité de temps à autre. Les changements importants seront communiqués par des moyens raisonnables, par exemple par publication d’une version mise à jour, avis dans le produit ou courriel. La date d’entrée en vigueur identifie la version actuelle."
          ]
        },
        {
          "title": "13. Contact",
          "paragraphs": [
            "BrioSocialize est développé et exploité par Brio Conception inc., 6927, rue Marie-Drouet, Trois-Rivières, Québec, G8Y 7H8, Canada. Les questions relatives à la vie privée ainsi que les demandes d’accès, de correction ou de suppression peuvent être transmises par le canal de contact disponible dans BrioSocialize ou par téléphone au +1 581 999-7540."
          ]
        }
      ]
    },
    "privacyDelete": {
      "meta": {
        "title": "Instructions de suppression des données BrioSocialize",
        "description": "Instructions pour demander la suppression des données de compte, d’application, d’espace et d’intégration dans BrioSocialize."
      },
      "eyebrow": "Confidentialité",
      "title": "Instructions de suppression des données",
      "description": "Cette page explique comment demander la suppression des données de compte, d’application, d’espace et d’intégration associées à BrioSocialize.",
      "effectiveDate": "Date d’entrée en vigueur : 18 juin 2026",
      "sections": [
        {
          "title": "1. Ce qui peut être supprimé",
          "paragraphs": [
            "Vous pouvez demander la suppression des renseignements personnels associés à votre compte BrioSocialize, y compris les renseignements de profil, registres d’authentification, données d’intégration et données personnelles liées à votre utilisation du service, sous réserve des limites ci-dessous.",
            "Les organisations et administrateurs d’espace peuvent aussi supprimer ou retirer des données au niveau de l’espace lorsque BrioSocialize offre cette capacité. Le contenu d’un espace peut appartenir à l’organisation ou au client qui contrôle cet espace; un utilisateur individuel ne peut donc pas toujours supprimer unilatéralement les registres de l’organisation."
          ]
        },
        {
          "title": "2. Comment demander la suppression de données de compte ou d’application",
          "paragraphs": [
            "Pour demander une suppression, communiquez avec BrioSocialize par le canal de contact disponible dans l’application ou le site public. Utilisez l’adresse courriel liée à votre compte BrioSocialize ou fournissez assez d’informations pour permettre à BrioSocialize de vérifier votre identité et la propriété du compte."
          ],
          "steps": [
            "Indiquez l’adresse courriel du compte et, le cas échéant, l’organisation ou l’espace concerné.",
            "Précisez que vous demandez la suppression de données de compte ou d’application BrioSocialize.",
            "Précisez si la demande vise votre compte personnel, une connexion sociale, une intégration fournisseur, une invitation à un espace ou du contenu d’espace.",
            "Répondez aux demandes raisonnables de vérification afin que BrioSocialize puisse protéger les comptes et registres d’espace contre les suppressions non autorisées.",
            "BrioSocialize confirmera la réception et traitera la demande dans le délai exigé par la loi applicable, sauf exception ou vérification supplémentaire."
          ]
        },
        {
          "title": "3. Connexion sociale et intégrations fournisseurs",
          "paragraphs": [
            "Si vous avez utilisé Google, Facebook ou un autre fournisseur pour vous connecter ou connecter un compte, vous pouvez aussi révoquer l’accès de BrioSocialize dans les paramètres de compte de ce fournisseur. La révocation de l’accès fournisseur ne supprime pas toujours les renseignements déjà stockés dans BrioSocialize; vous devez donc aussi soumettre une demande de suppression si vous voulez supprimer les données détenues par BrioSocialize.",
            "La suppression de données dans BrioSocialize ne supprime pas les publications, commentaires, fichiers, messages, analyses ou registres de compte stockés par des plateformes tierces. Vous devez utiliser les outils de la plateforme tierce applicable pour les renseignements détenus par cette plateforme."
          ]
        },
        {
          "title": "4. Renseignements pouvant être conservés",
          "paragraphs": [
            "BrioSocialize peut conserver certains renseignements lorsque la conservation est requise ou permise pour la sécurité, la prévention de la fraude, la conformité légale, les registres financiers, les pistes d’audit, la résolution des différends, l’intégrité des sauvegardes, l’application des conditions ou la protection des droits de BrioSocialize, des utilisateurs, des organisations ou de tiers."
          ],
          "items": [
            "Les journaux de sécurité et registres de prévention des abus peuvent être conservés pendant une période limitée.",
            "Les registres de facturation, fiscaux, de paiement et comptables peuvent être conservés conformément à la loi.",
            "L’historique d’audit d’un espace, les registres d’approbation et l’historique de contenu peuvent être conservés lorsqu’ils sont contrôlés par une organisation ou nécessaires pour préserver l’intégrité du workflow.",
            "Les sauvegardes peuvent contenir des renseignements supprimés jusqu’à leur remplacement dans les cycles ordinaires de sauvegarde.",
            "Les renseignements anonymisés ou agrégés qui ne permettent plus de vous identifier peuvent être conservés."
          ]
        },
        {
          "title": "5. Après la suppression",
          "paragraphs": [
            "Une fois la suppression complétée, vous pourriez perdre l’accès à votre compte, aux invitations, espaces, commentaires, approbations, notifications, intégrations et registres de workflow connexes. La suppression peut être irréversible.",
            "Si votre compte avait été invité par une organisation, cette organisation pourrait devoir vous inviter de nouveau avant que vous puissiez retrouver l’accès."
          ]
        }
      ]
    }
  },
  "common": {
    "back": "Retour",
    "cancel": "Annuler",
    "creating": "Création...",
    "next": "Suivant",
    "saving": "Enregistrement..."
  },
  "workspaceSelector": {
    "createAction": "Ajouter un espace",
    "organizationLabel": "Organisation",
    "organizationSettings": "Parametres de l'organisation",
    "noOrganization": "Aucune organisation",
    "workspaceSettings": "Parametres de l'espace"
  },
  "workspaceCreate": {
    "eyebrow": "Espace",
    "title": "Creer un nouvel espace",
    "description": "Configurez un nouvel espace avec son fuseau horaire, ses membres et son workflow.",
    "formTitle": "Details de l'espace",
    "formDescription": "Commencez par les champs essentiels. Les membres et le workflow peuvent etre configures juste apres la creation.",
    "createAction": "Creer l'espace",
    "fields": {
      "name": "Nom de l'espace",
      "namePlaceholder": "Northwind Studio",
      "organization": "Organisation",
      "timeZone": "Fuseau horaire"
    },
    "errors": {
      "required": "Tous les champs de l'espace sont requis.",
      "createFailed": "L'espace n'a pas pu etre cree."
    }
  },
  "organizationOnboarding": {
    "eyebrow": "Pour adapter Socialize à votre workflow",
    "title": "Parlez-nous un peu de votre équipe",
    "progress": "Étape {current} sur {total}",
    "progressLabel": "Progression de l'accueil",
    "finish": "Terminer",
    "steps": {
      "organization": "Organisation",
      "survey": "Profil d'équipe",
      "workspace": "Espace / marque",
      "members": "Membres",
      "channels": "Canaux sociaux",
      "approval": "Type d'approbation"
    },
    "stepInvites": {
      "organization": "Commencez par l'identité de compte que votre équipe reconnaîtra dans les espaces.",
      "survey": "Adaptez la configuration à votre façon de travailler sans enregistrer les réponses pour l'instant.",
      "workspace": "Créez le premier espace de marque ou de client où le contenu sera géré.",
      "members": "Invitez les collègues, clients ou prestataires qui doivent rejoindre cet espace.",
      "channels": "Ajoutez les destinations sociales que cet espace planifie, révise et approuve.",
      "approval": "Choisissez le niveau d'approbation requis avant que le contenu avance."
    },
    "errors": {
      "saveFailed": "Cette étape n'a pas pu être enregistrée.",
      "unsupportedImage": "Choisissez une image PNG, JPG, GIF ou WebP."
    },
    "create": {
      "fields": {
        "name": "Nom de l'organisation",
        "logo": "Logo de l'organisation",
        "namePlaceholder": "Agence Northstar",
        "membershipTier": "Forfait"
      },
      "logoEditorTitle": "Modifier le logo de l'organisation",
      "tiers": {
        "freePrice": "Gratuit",
        "monthlyPrice": "{price}/mois",
        "customPrice": "Sur mesure"
      },
      "errors": {
        "required": "Le nom de l'organisation est requis.",
        "failed": "L'organisation n'a pas pu etre creee."
      }
    },
    "survey": {
      "fields": {
        "peopleCount": "Nombre de personnes",
        "usage": "Usage principal"
      },
      "types": {
        "agency": "Agence",
        "freelance": "Freelance",
        "brand": "Marque",
        "other": "Autre"
      },
      "people": {
        "one": "Juste moi",
        "small": "2 à 10 personnes",
        "medium": "11 à 50 personnes",
        "large": "51+ personnes"
      },
      "usage": {
        "review": "Révision de contenu",
        "calendar": "Calendrier de planification",
        "clients": "Approbations client",
        "assets": "Transfert d'assets"
      }
    },
    "workspace": {
      "fields": {
        "name": "Nom de l'espace ou de la marque",
        "namePlaceholder": "Social Northstar",
        "logo": "Logo de l'espace"
      },
      "logoEditorTitle": "Modifier le logo de l'espace",
      "errors": {
        "required": "Le nom de l'espace et le fuseau horaire sont requis."
      }
    },
    "logoEditor": {
      "chooseAction": "Choisir une image",
      "saveAction": "Utiliser l'image modifiée"
    },
    "members": {
      "inviteSaved": "Invitation créée.",
      "cancelInvite": "Annuler l'invitation",
      "cancelFailed": "L'invitation n'a pas pu être annulée."
    },
    "channels": {
      "saved": "Canal créé.",
      "errors": {
        "required": "Le nom du canal est requis."
      }
    },
    "approval": {
      "defaultStepName": "Approbation gestionnaire"
    }
  },
  "billingSettings": {
    "loading": "Chargement des informations de facturation",
    "retry": "Réessayer",
    "providerUnavailable": "Les détails de paiement sont temporairement indisponibles. Les informations d'abonnement restent affichées ci-dessous.",
    "currentPlan": "Forfait actuel",
    "comparePlans": "Comparer les forfaits",
    "transactionHistory": "Historique des transactions",
    "transactionDescription": "Reçus et factures d'abonnement.",
    "noTransactions": "Aucune transaction. Les factures payées apparaîtront ici.",
    "viewAll": "Tout afficher",
    "date": "Date",
    "status": "État",
    "amount": "Montant",
    "statuses": {
      "active": "Actif",
      "trialing": "Essai",
      "pastdue": "Paiement en retard",
      "canceled": "Annulé",
      "incomplete": "Paiement en attente",
      "none": "Gratuit",
      "paid": "Payée",
      "open": "Ouverte",
      "draft": "Brouillon",
      "void": "Annulée",
      "failed": "Échouée"
    },
    "billingInformation": "Informations de facturation",
    "informationDescription": "Utilisées pour les factures et les dossiers du fournisseur de paiement.",
    "edit": "Modifier",
    "notProvided": "Non fourni",
    "paymentMethods": "Modes de paiement",
    "methodsDescription": "Les cartes sont conservées de façon sécurisée par Stripe.",
    "addNew": "Ajouter",
    "default": "Par défaut",
    "cardActions": "Actions pour la carte se terminant par {last4}",
    "makeDefault": "Définir par défaut",
    "remove": "Supprimer",
    "noPaymentMethods": "Aucun mode de paiement enregistré. Ajoutez une carte avant de choisir un forfait payant.",
    "reactivatePlan": "Réactiver le forfait",
    "cancelPlan": "Annuler le forfait",
    "keepRenewing": "Conserver le renouvellement du forfait après le {date}.",
    "cancelDescription": "En cas d'annulation, l'accès demeure actif jusqu'à la fin de la période de facturation.",
    "reactivate": "Réactiver",
    "cancel": "Annuler",
    "custom": "Sur mesure",
    "free": "Gratuit",
    "perMonth": "{price}/mois",
    "unlimited": "Illimité",
    "overLimit": "L'utilisation actuelle de {usage} ({used}) dépasse la limite de ce forfait ({limit}). Le changement peut être planifié, mais tout nouvel usage sera bloqué dès son entrée en vigueur.",
    "contactUs": "Nous joindre",
    "choosePlan": "Choisir ce forfait",
    "planUnavailable": "Temporairement indisponible",
    "planUnavailableDescription": "Ce forfait payant est temporairement indisponible pendant la configuration de son prix chez le fournisseur de paiement.",
    "close": "Fermer",
    "editInformation": "Modifier les informations de facturation",
    "save": "Enregistrer",
    "addPaymentMethod": "Ajouter un mode de paiement",
    "secureCardDescription": "Les détails de la carte sont transmis directement à Stripe et ne passent jamais par Socialize.",
    "saveCard": "Enregistrer la carte",
    "cancelQuestion": "Annuler {plan}?",
    "cancelDialogDescription": "L'accès au forfait demeure actif jusqu'au {date}. L'organisation revient ensuite aux limites du forfait Gratuit.",
    "keepPlan": "Conserver le forfait",
    "scheduleCancellation": "Planifier l'annulation",
    "loadMore": "Charger plus",
    "confirmRemove": "Supprimer la carte {brand} se terminant par {last4}?",
    "fields": {
      "email": "Courriel de facturation",
      "name": "Nom",
      "address": "Adresse",
      "companyName": "Nom ou entreprise",
      "addressLine1": "Adresse, ligne 1",
      "addressLine2": "Adresse, ligne 2",
      "city": "Ville",
      "region": "Province ou État",
      "postalCode": "Code postal",
      "countryCode": "Code du pays"
    },
    "limits": {
      "workspaces": "{count} espaces de travail",
      "members": "{count} membres",
      "activeContent": "{count} contenus actifs",
      "externalReviewers": "{count} réviseurs externes"
    },
    "messages": {
      "accessUntil": "L'accès demeure actif jusqu'au {date}.",
      "changesOn": "Passage au forfait {plan} le {date}.",
      "pastDue": "Le paiement est en retard. Mettez votre carte à jour avant le {date}.",
      "confirmPayment": "Une confirmation de paiement est requise avant l'activation du forfait payant.",
      "renewsOn": "Renouvellement le {date}.",
      "upgrade": "Passez à un forfait supérieur lorsque votre organisation a besoin de plus de capacité.",
      "informationSaved": "Informations de facturation enregistrées.",
      "methodAdded": "Mode de paiement ajouté.",
      "planScheduled": "Changement de forfait planifié.",
      "planUpdated": "Forfait mis à jour.",
      "cancellationScheduled": "Annulation planifiée.",
      "reactivated": "Abonnement réactivé.",
      "defaultUpdated": "Mode de paiement par défaut mis à jour.",
      "methodRemoved": "Mode de paiement supprimé."
    },
    "errors": {
      "stripeLoad": "Stripe.js n'a pas pu être chargé.",
      "confirmationLoad": "La confirmation sécurisée du paiement n'a pas pu être chargée. Réessayez.",
      "setupFailed": "Le mode de paiement n'a pas pu être enregistré. Vérifiez les renseignements de la carte et réessayez."
    }
  },
  "organizationSettings": {
    "eyebrow": "Organisation",
    "title": "Parametres de l'organisation",
    "description": "Gerez le compte SaaS pour les membres, l'utilisation et la facturation.",
    "loading": "Chargement des parametres de l'organisation...",
    "saving": "Enregistrement...",
    "saveProfile": "Enregistrer le profil",
    "editName": "Modifier le nom de l'organisation",
    "saveName": "Enregistrer le nom de l'organisation",
    "cancelNameEdit": "Annuler la modification du nom",
    "profileSaved": "Profil de l'organisation enregistre.",
    "addMember": "Ajouter un membre",
    "addingMember": "Ajout...",
    "memberAdded": "Membre de l'organisation ajoute.",
    "sendInvite": "Inviter",
    "sendingInvite": "Envoi...",
    "inviteSent": "Invitation d'organisation envoyee.",
    "cancelInvite": "Annuler l'invitation",
    "inviteCancelled": "Invitation d'organisation annulee.",
    "resendInvite": "Renvoyer l'email",
    "editPermissions": "Modifier les permissions",
    "editRole": "Modifier le role",
    "saveRole": "Enregistrer le role",
    "roleUpdated": "Role du membre mis a jour.",
    "removeMember": {
      "action": "Retirer le membre",
      "confirm": "Retirer {name} de cette organisation ?",
      "removed": "Membre de l'organisation retire."
    },
    "delete": {
      "title": "Supprimer l'organisation",
      "description": "Supprime cette organisation et tous les espaces qu'elle detient. L'organisation disparait des vues normales de l'application et ne peut pas etre restauree depuis les parametres.",
      "confirmationLabel": "Tapez {name} pour supprimer cette organisation",
      "action": "Supprimer l'organisation",
      "deleting": "Suppression...",
      "confirmationMismatch": "Tapez le nom exact de l'organisation pour la supprimer."
    },
    "default": {
      "action": "Definir par defaut",
      "badge": "Organisation par defaut",
      "currentAction": "Organisation par defaut",
      "saved": "Organisation par defaut mise a jour."
    },
    "logo": {
      "title": "Logo de l'organisation",
      "description": "Affiche dans les parametres et les selecteurs d'organisation.",
      "changeAction": "Changer le logo",
      "chooseAction": "Choisir un logo",
      "cropperTitle": "Modifier le logo de l'organisation",
      "saveAction": "Enregistrer le logo",
      "saving": "Enregistrement...",
      "saved": "Logo de l'organisation enregistre."
    },
    "fields": {
      "name": "Nom",
      "memberEmail": "Email du membre",
      "memberRole": "Role",
      "relationshipType": "Relation",
      "membershipTier": "Forfait",
      "createdAt": "Cree"
    },
    "errors": {
      "nameRequired": "Le nom de l'organisation est requis.",
      "profileSaveFailed": "Le profil de l'organisation n'a pas pu etre enregistre.",
      "memberRequired": "L'email et le role sont requis pour ajouter un membre.",
      "memberAddFailed": "Le membre de l'organisation n'a pas pu etre ajoute. Les utilisateurs existants peuvent etre ajoutes par email.",
      "inviteRequired": "L'email et le role sont requis pour inviter un membre.",
      "emailRequired": "Entrez une adresse email.",
      "emailInvalid": "Entrez une adresse email valide.",
      "inviteFailed": "L'invitation d'organisation n'a pas pu etre envoyee.",
      "inviteCancelFailed": "L'invitation d'organisation n'a pas pu etre annulee.",
      "memberRemoveFailed": "Le membre de l'organisation n'a pas pu etre retire.",
      "roleUpdateFailed": "Le role du membre n'a pas pu etre mis a jour.",
      "defaultSaveFailed": "L'organisation par defaut n'a pas pu etre mise a jour.",
      "logoUploadFailed": "Le logo de l'organisation n'a pas pu etre enregistre.",
      "membershipTierRequired": "Selectionnez un forfait.",
      "tierSaveFailed": "Le forfait n'a pas pu etre mis a jour.",
      "deleteFailed": "L'organisation n'a pas pu etre supprimee."
    },
    "sections": {
      "profile": {
        "title": "Profil",
        "description": "L'identite du compte utilisee dans les espaces detenus par l'organisation."
      },
      "members": {
        "title": "Membres",
        "description": "Utilisateurs de l'organisation et leurs permissions heritees.",
        "inviteTitle": "Inviter",
        "currentMembers": "Membres actuels",
        "pendingInvites": "Invitations en attente",
        "access": "Acces",
        "status": "Statut",
        "inviteStatus": "Invitation {status}",
        "noPendingInvites": "Aucune invitation en attente.",
        "empty": "Aucun membre d'organisation trouve."
      },
      "usage": {
        "title": "Utilisation",
        "description": "Utilisation actuelle de l'organisation par rapport aux limites du forfait.",
        "planLabel": "Forfait actuel",
        "planFallback": "Aucun forfait configure",
        "empty": "Aucune donnee d'utilisation n'est disponible pour le moment."
      },
      "billing": {
        "title": "Facturation",
        "description": "Acces a l'abonnement et a la facturation de cette organisation.",
        "placeholderTitle": "Le fournisseur de facturation n'est pas encore connecte",
        "placeholderText": "La gestion du forfait, des paiements et des factures sera ajoutee ici apres l'integration de facturation."
      },
      "workspaces": {
        "title": "Espaces",
        "description": "Espaces de marque et de client detenus par cette organisation.",
        "empty": "Aucun espace n'appartient encore a cette organisation."
      }
    },
    "usage": {
      "unlimited": "Illimite",
      "items": {
        "users": "Utilisateurs",
        "workspaces": "Espaces",
        "activeContent": "Contenu actif",
        "externalReviewers": "Reviseurs externes",
        "storage": "Espace de stockage"
      }
    },
    "tiers": {
      "freePrice": "Gratuit",
      "monthlyPrice": "{price}/mois",
      "customPrice": "Sur mesure",
      "summary": "{price} - {workspaces} espaces, {members} membres, {activeContent} contenus actifs, {storage} de stockage"
    },
    "roles": {
      "Owner": "Proprietaire",
      "Administrator": "Administrateur",
      "Contributor": "Contributeur",
      "Writer": "Redacteur",
      "Reviewer": "Reviseur",
      "Guest": "Invite",
      "Admin": "Administrateur",
      "BillingManager": "Gestionnaire facturation",
      "ConnectorManager": "Gestionnaire connecteurs",
      "Member": "Membre"
    },
    "accessRoles": {
      "administrator": {
        "label": "Administrateur",
        "description": "Toutes les permissions, y compris la gestion des utilisateurs, pages, commentaires, facturation, connecteurs et espaces."
      },
      "contributor": {
        "label": "Contributeur",
        "description": "Peut creer et modifier des publications et commentaires, puis publier ou planifier du contenu."
      },
      "writer": {
        "label": "Redacteur",
        "description": "Peut creer et modifier des publications et commentaires."
      },
      "reviewer": {
        "label": "Reviseur",
        "description": "Peut reviser et approuver des publications et commentaires."
      },
      "guest": {
        "label": "Invite",
        "description": "Peut consulter les publications et commentaires."
      }
    },
    "relationshipTypes": {
      "OrganizationMember": "Membre",
      "ExternalCollaborator": "Collaborateur",
      "Member": "Membre",
      "External": "Externe",
      "Client": "Client"
    },
    "permissions": {
      "title": "Vos permissions",
      "description": "Permissions d'organisation retournees par l'API.",
      "read": "Lecture",
      "write": "Ecriture",
      "items": {
        "ManageOrganizationSettings": "Gerer les parametres",
        "ManageOrganizationMembers": "Gerer les membres",
        "CreateWorkspaces": "Creer des espaces",
        "ManageWorkspaces": "Gerer les espaces",
        "ManageBilling": "Gerer la facturation",
        "ManageConnectors": "Gerer les connecteurs",
        "AccessOwnedWorkspaces": "Acceder aux espaces detenus"
      }
    }
  },
  "nav": {
    "brandStage": "Aperçu alpha",
    "brandStageLabel": "Statut du produit : aperçu alpha",
    "brandCaption": "Flux d'approbation",
    "workspace": "Espace de travail",
    "notifications": "Notifications",
    "dashboard": "Tableau de bord",
    "overview": "Vue globale",
    "calendar": "Calendrier",
    "workspacePlan": "Calendrier",
    "mediaLibrary": "Bibliotheque media",
    "publishing": "Publication",
    "myFeedback": "Mon feedback",
    "feedbackReview": "Revue feedback",
    "whatsNew": "Nouveautés",
    "releaseUpdates": "Mises à jour",
    "releaseNotes": "Notes de version",
    "billingCatalog": "Catalogue de facturation",
    "channels": "Canaux",
    "campaigns": "Campagnes",
    "reviewQueue": "File de révision",
    "content": "Contenu",
    "profile": "Profil",
    "signIn": "Se connecter",
    "settings": "Paramètres",
    "language": "Langue",
    "signOut": "Se déconnecter",
    "noWorkspace": "Aucun espace"
  },
  "developerBilling": {
    "eyebrow": "Opérateur SaaS",
    "title": "Tarification du fournisseur",
    "description": "Associez les forfaits Socialize aux prix récurrents validés du fournisseur de paiement actif.",
    "boundaryNote": "Socialize demeure la source de vérité pour les fonctions et les montants des forfaits. Les identifiants de prix {provider} servent uniquement de références pour les futurs achats.",
    "providerFallback": "Fournisseur de paiement",
    "loading": "Chargement des associations de prix",
    "retry": "Réessayer",
    "current": "Association actuelle",
    "amount": "Montant",
    "billingCycle": "Cycle de facturation",
    "activated": "Activée",
    "addMapping": "Ajouter une association",
    "changeMapping": "Changer l'association",
    "retire": "Retirer",
    "unmapped": "Achats indisponibles",
    "unmappedDescription": "Les clients ne peuvent pas choisir ce forfait payant avant qu'un prix courant du fournisseur soit associé.",
    "history": "Historique des associations",
    "retiredOn": "Retirée le {date}",
    "empty": "Aucune association de prix du fournisseur n'existe.",
    "dialogTitle": "Valider le prix du fournisseur",
    "dialogDescription": "Collez un identifiant de prix {provider} existant. Socialize vérifie son état actif, son intervalle récurrent, sa devise et son montant avant de l'activer.",
    "priceReference": "Identifiant de prix {provider}",
    "validationNote": "Le changement touche uniquement les futurs achats. Les abonnements existants conservent leur prix historique.",
    "validateAndActivate": "Valider et activer",
    "retireTitle": "Retirer cette association?",
    "retireDescription": "Les nouveaux achats de ce forfait seront indisponibles jusqu'à l'activation d'un autre prix. Les abonnements existants ne changent pas.",
    "messages": {
      "activated": "Prix du fournisseur validé et activé.",
      "retired": "Association de prix du fournisseur retirée."
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread": "non lues",
    "loading": "Chargement des notifications...",
    "empty": "Aucune notification de workflow pour le moment.",
    "events": {
      "approvalRequested": "Approbation demandée",
      "approvalDecisionRecorded": "Décision d'approbation enregistrée",
      "commentCreated": "Commentaire ajouté",
      "commentResolved": "Commentaire résolu",
      "contentCreated": "Élément de contenu créé",
      "revisionCreated": "Révision créée",
      "statusUpdated": "Statut mis à jour",
      "assetLinked": "Ressource liée",
      "assetRevisionCreated": "Révision de ressource créée",
      "feedbackReportCreated": "Nouveau rapport de feedback",
      "feedbackDeveloperCommented": "Commentaire développeur",
      "feedbackStatusChanged": "Statut du feedback modifié",
      "feedbackReporterCommented": "Réponse du rapporteur"
    }
  },
  "appSearch": {
    "placeholder": "Rechercher",
    "ariaLabel": "Rechercher du contenu et des sections de l'app",
    "contentGroup": "Contenus",
    "navigationGroup": "App",
    "loading": "Recherche de contenu...",
    "noResults": "Aucun résultat trouvé.",
    "error": "La recherche est indisponible."
  },
  "releaseCommunications": {
    "summary": "Résumé",
    "description": "Description",
    "noteTitle": "Titre",
    "english": "Anglais",
    "french": "Français",
    "titleEn": "Titre anglais",
    "descriptionEn": "Description anglaise",
    "titleFr": "Titre français",
    "descriptionFr": "Description française",
    "body": "Détail",
    "category": "Catégorie",
    "importance": "Importance",
    "audience": "Audience",
    "deploymentLabel": "Libellé de déploiement",
    "buildVersion": "Version build",
    "commitRange": "Plage de commits",
    "emptyValue": "Non défini",
    "errors": {
      "loadFailed": "Impossible de charger les mises à jour produit."
    },
    "user": {
      "eyebrow": "Mises à jour produit",
      "title": "Nouveautés",
      "description": "Fonctionnalités, améliorations et corrections publiées depuis votre dernière visite.",
      "markAllRead": "Tout marquer lu",
      "empty": "Aucune mise à jour publiée pour le moment."
    },
    "developer": {
      "eyebrow": "Opérateur SaaS",
      "title": "Mises à jour release",
      "description": "Créez, publiez et archivez les mises à jour produit rédigées.",
      "creationTitle": "Note de release",
      "creationDescription": "Rédigez une note depuis les commits sélectionnés ou modifiez une release existante.",
      "createReleaseNote": "Créer une note de release",
      "createFirstRelease": "Créer la première release",
      "noReleaseNotes": "Aucune note de release pour le moment.",
      "newUpdate": "Nouvelle mise à jour",
      "publish": "Publier",
      "archive": "Archiver",
      "forceDigest": "Envoyer l'email quotidien",
      "forceDigestConfirm": "Envoyer maintenant l'email quotidien des releases a chaque utilisateur eligible avec des mises a jour non lues ?",
      "forceDigestResult": "Email quotidien des releases envoye a {count} utilisateurs.",
      "linkedCommits": "Commits liés",
      "noLinkedCommits": "Aucun commit lié à cette mise à jour."
    },
    "commits": {
      "eyebrow": "Opérateur SaaS",
      "title": "Notes de release",
      "description": "Révisez les commits en attente et gérez l'historique des notes de release.",
      "gitLogTab": "Changements",
      "releaseNotesTab": "Historique",
      "refresh": "Actualiser",
      "exclude": "Exclure",
      "unreviewed": "non révisés",
      "branch": "Branche ou ref",
      "limit": "Limite",
      "since": "Depuis",
      "until": "Jusqu'au",
      "fetch": "Récupérer commits",
      "importResult": "{imported} importés, {updated} mis à jour, {skipped} ignorés.",
      "search": "Recherche",
      "status": "Statut",
      "linkedUpdate": "Mise à jour liée",
      "releaseNote": "Note de release",
      "notIncluded": "Non inclus",
      "inclusion": {
        "label": "Statut de note",
        "notIncluded": "Non inclus dans une note",
        "included": "Inclus dans une note",
        "all": "Tous les commits"
      },
      "author": "Auteur",
      "sha": "SHA",
      "commit": "Commit",
      "committed": "Commité",
      "actions": "Actions",
      "empty": "Aucun commit ne correspond aux filtres actuels.",
      "clear": "Effacer",
      "link": "Mise à jour",
      "selected": "{count} sélectionnés",
      "selectCommit": "Sélectionner le commit",
      "copied": "Copié.",
      "createUpdate": "Créer la note de release",
      "selectedCommits": "Commits sélectionnés",
      "internalOnly": "Interne seulement",
      "ignore": "Ignorer"
    }
  },
  "feedback": {
    "button": "Feedback",
    "open": "Envoyer un feedback produit",
    "eyebrow": "Feedback produit",
    "title": "Envoyer un feedback",
    "capture": "Capturer l'écran",
    "removeCapture": "Retirer la capture",
    "noCapture": "Capturez la vue actuelle de l'application si une image peut aider.",
    "captureFailed": "La capture d'écran n'a pas pu être faite. Vous pouvez quand même envoyer un feedback sans image.",
    "submit": "Envoyer le feedback",
    "submitted": "Feedback envoyé.",
    "submitFailed": "Le feedback n'a pas pu être envoyé.",
    "discardConfirm": "Supprimer ce feedback non envoyé ?",
    "textPrompt": "Libellé texte",
    "types": {
      "bug": "Bug",
      "suggestion": "Suggestion",
      "request": "Demande"
    },
    "fields": {
      "type": "Type",
      "description": "Description",
      "descriptionPlaceholder": "Décrivez ce qui s'est produit, ce que vous attendiez ou ce qui améliorerait le workflow."
    },
    "tools": {
      "crop": "Recadrer",
      "arrow": "Flèche",
      "ellipse": "Cercle",
      "line": "Ligne",
      "freehand": "Main levée",
      "text": "Texte",
      "undo": "Annuler",
      "clear": "Effacer et réinitialiser"
    },
    "review": {
      "eyebrow": "Revue développeur",
      "title": "Feedback produit",
      "description": "Passez en revue les bugs, suggestions et demandes soumis dans tous les espaces.",
      "refresh": "Actualiser le feedback",
      "loading": "Chargement du feedback...",
      "empty": "Aucun feedback ne correspond aux filtres actuels.",
      "emptyValue": "Non capturé",
      "noContext": "Aucun contexte d'espace",
      "lastActivity": "Dernière activité",
      "metrics": {
        "total": "Rapports totaux",
        "visible": "Visibles",
        "new": "Nouveaux",
        "planned": "Planifiés"
      },
      "filters": {
        "search": "Rechercher du feedback",
        "type": "Type",
        "status": "Statut",
        "tag": "Tag",
        "reporter": "Rapporteur",
        "workspace": "Espace",
        "fromDate": "Date de début",
        "toDate": "Date de fin",
        "sort": "Tri",
        "clear": "Effacer les filtres"
      },
      "sort": {
        "lastActivity": "Dernière activité",
        "newest": "Plus récent",
        "oldest": "Plus ancien"
      },
      "errors": {
        "loadFailed": "Le feedback n'a pas pu être chargé.",
        "detailFailed": "Le rapport de feedback n'a pas pu être chargé."
      },
      "detail": {
        "back": "Retour au feedback",
        "eyebrow": "Détail du feedback",
        "report": "Rapport",
        "screenshot": "Capture d'écran",
        "download": "Télécharger l'original",
        "openOriginal": "Ouvrir l'original",
        "screenshotAlt": "Capture d'écran du feedback",
        "noScreenshot": "Aucune capture n'a été jointe.",
        "timeline": "Commentaires et activité",
        "noTimeline": "Aucun commentaire ou activité pour le moment.",
        "commentLabel": "Commentaire développeur",
        "addComment": "Ajouter un commentaire",
        "commenting": "Ajout du commentaire...",
        "commentAdded": "Commentaire ajouté.",
        "commentFailed": "Le commentaire n'a pas pu être ajouté.",
        "reviewControls": "Contrôles de revue",
        "saved": "Feedback mis à jour.",
        "saveFailed": "Le feedback n'a pas pu être mis à jour.",
        "reporter": "Rapporteur",
        "activityLabel": "Activité",
        "metadata": {
          "title": "Métadonnées capturées",
          "path": "Chemin soumis",
          "userAgent": "Navigateur",
          "viewport": "Fenêtre",
          "appVersion": "Version de l'app",
          "created": "Créé",
          "lastActivity": "Dernière activité"
        },
        "context": {
          "title": "Contexte",
          "workspace": "Espace",
          "client": "Client",
          "campaign": "Campagne",
          "contentItem": "Élément de contenu"
        },
        "activity": {
          "updated": "Feedback mis à jour.",
          "statusChanged": "Statut modifié de {from} à {to}.",
          "typeChanged": "Type modifié de {from} à {to}.",
          "tagsChanged": "Tags modifiés de {from} à {to}."
        }
      }
    },
    "mine": {
      "eyebrow": "Mon feedback",
      "title": "Mon feedback",
      "description": "Suivez le feedback produit que vous avez soumis dans tous les espaces.",
      "refresh": "Actualiser mon feedback",
      "empty": "Aucun feedback ne correspond aux filtres actuels.",
      "unread": "Activité de feedback non lue",
      "metrics": {
        "active": "Rapports actifs",
        "unread": "Non lus",
        "visible": "Visibles"
      },
      "errors": {
        "loadFailed": "Votre feedback n'a pas pu être chargé.",
        "detailFailed": "Ce rapport de feedback n'a pas pu être chargé."
      },
      "detail": {
        "back": "Retour à mon feedback",
        "eyebrow": "Détail de mon feedback",
        "commentLabel": "Commentaire de suivi",
        "commentAdded": "Commentaire ajouté.",
        "commentFailed": "Le commentaire n'a pas pu être ajouté.",
        "cancel": "Annuler le rapport",
        "cancelPrompt": "Raison d'annulation optionnelle",
        "cancelled": "Feedback annulé.",
        "cancelFailed": "Le feedback n'a pas pu être annulé."
      }
    }
  },
  "sidebar": {
    "expand": "Ouvrir la barre latérale",
    "collapse": "Fermer la barre latérale",
    "allChannels": "Tous les canaux",
    "allCampaigns": "Toutes les campagnes",
    "allReviewItems": "File de révision complète",
    "noChannels": "Aucun canal pour le moment.",
    "noCampaigns": "Aucune campagne pour le moment.",
    "noReviewItems": "Aucun élément à réviser pour le moment."
  },
  "settings": {
    "eyebrow": "Paramètres",
    "title": "Paramètres du compte",
    "userInformation": "Informations utilisateur",
    "workspaces": "Espaces de travail"
  },
  "dashboard": {
    "eyebrow": "Calendrier de l'espace",
    "title": "Calendrier",
    "description": "Voyez ce qui est prévu pour une journée donnée et consultez l'agenda des publications dans l'ordre.",
    "workspaceLabel": "Espace actif",
    "loading": "Chargement des données de l'espace...",
    "calendarKicker": "Agenda du jour",
    "executionKicker": "À venir",
    "riskKicker": "Risque de livraison",
    "reviewKicker": "État des révisions",
    "upcomingContent": "Contenu à venir",
    "deliveryRisks": "Ce qui peut glisser",
    "overdueItems": "Éléments en retard",
    "approvalBlockers": "En attente d'approbation ou de révision",
    "unscheduledCampaigns": "Campagnes sans contenu planifié",
    "reviewQueueSnapshot": "Aperçu de la file de révision",
    "emptyUpcoming": "Aucun contenu planifié à venir.",
    "emptyOverdue": "Rien n'est en retard pour le moment.",
    "emptyApproval": "Aucun blocage d'approbation pour le moment.",
    "emptyCampaigns": "Chaque campagne a au moins un élément de contenu planifié.",
    "emptyReviewQueue": "Aucun élément actif dans la file de révision.",
    "previousDay": "Jour précédent",
    "nextDay": "Jour suivant",
    "today": "Aujourd'hui",
    "day": "Jour",
    "month": "Mois",
    "week": "Semaine",
    "campaignDeadline": "Échéance de campagne",
    "emptyPeriod": "Aucun élément planifié.",
    "daySummary": "{content} contenus · {campaigns} échéances de campagne",
    "moreItems": "+{count} autres",
    "emptyDayAgenda": "Aucun contenu n'est planifié pour cette journée.",
    "campaignProgress": "{scheduled} planifiés · {approved} approuvés",
    "missingSchedule": "Contenu à planifier",
    "noDueDate": "Aucune échéance",
    "labels": {
      "unassignedCampaign": "Campagne non attribuée"
    },
    "readiness": {
      "building": "En production",
      "approval": "En attente d'approbation",
      "rework": "Révision requise",
      "ready": "Approuvé",
      "published": "Publié",
      "blocked": "Bloqué",
      "archived": "Archivé",
      "scheduled": "Planifié",
      "missing": "Aucun contenu planifié"
    },
    "stats": {
      "scheduledThisDay": "Planifiés ce jour",
      "overdue": "En retard",
      "awaitingApproval": "En attente d'approbation",
      "readyToShip": "Prêts à livrer"
    }
  },
  "overview": {
    "eyebrow": "Vue portefeuille",
    "title": "Chronologie multi-espaces",
    "description": "Suivez les livraisons à venir, les risques et l'activité sur tous les espaces auxquels vous avez accès.",
    "loading": "Chargement des données globales...",
    "workspacesKicker": "Périmètre d'accès",
    "workspaceRollup": "Synthèse des espaces",
    "timelineKicker": "À venir",
    "upcomingTitle": "Planifié sur tous les espaces",
    "riskKicker": "À surveiller",
    "risksTitle": "Éléments déjà à risque",
    "activityKicker": "Activité récente",
    "activityTitle": "Derniers événements du workflow",
    "emptyUpcoming": "Aucun élément planifié à venir sur vos espaces.",
    "emptyRisks": "Aucun risque de livraison multi-espace pour le moment.",
    "emptyActivity": "Aucune activité récente du workflow.",
    "labels": {
      "campaigns": "campagnes",
      "upcoming": "à venir",
      "blocked": "bloqués"
    },
    "stats": {
      "workspaces": "Espaces",
      "campaigns": "Campagnes",
      "upcoming": "Éléments à venir",
      "blockers": "Éléments à risque"
    }
  },
  "campaigns": {
    "eyebrow": "Planification des campagnes",
    "title": "Campagnes",
    "description": "Campagnes regroupées dans l'espace actif par statut, plage de dates et notes de planification.",
    "newCampaign": "Nouvelle campagne",
    "createTitle": "Créer une campagne",
    "loading": "Chargement des campagnes...",
    "empty": "Aucune campagne n'est disponible pour l'espace actif.",
    "noDateRange": "Aucune plage de dates",
    "errors": {
      "required": "Le nom de la campagne et la plage de dates sont requis.",
      "invalidDateRange": "La date de fin doit être postérieure ou égale à la date de début.",
      "createFailed": "La campagne n'a pas pu être créée."
    },
    "fields": {
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "name": "Nom de la campagne",
      "description": "Description",
      "notes": "Notes"
    }
  },
  "channels": {
    "title": "Canaux",
    "description": "Ajoutez des canaux à l'espace.",
    "createTitle": "Créer un canal",
    "editTitle": "Modifier le canal",
    "saveChanges": "Enregistrer",
    "empty": "Aucun canal n'est disponible pour l'espace actif pour le moment.",
    "emptyAction": "Ajouter un canal pour {network}",
    "nextDue": "Prochaine échéance",
    "noScheduled": "Rien de planifié",
    "fields": {
      "name": "Nom du canal",
      "network": "Réseau",
      "handle": "Identifiant",
      "externalUrl": "URL externe",
      "portraitUrl": "URL du portrait",
      "bannerUrl": "URL de la bannière"
    },
    "actions": {
      "changePortrait": "Changer le portrait",
      "changeBanner": "Changer la bannière"
    },
    "metrics": {
      "scheduled": "Planifié",
      "ready": "Prêt",
      "blocked": "Bloqué"
    },
    "errors": {
      "createFailed": "Le canal n'a pas pu être créé.",
      "updateFailed": "Le canal n'a pas pu être modifié."
    }
  },
  "reviewQueue": {
    "eyebrow": "Flux de révision",
    "title": "File de révision",
    "description": "Approbations, révisions et demandes de changement en attente pour l'espace actif.",
    "empty": "Aucun élément de révision n'est disponible pour l'espace actif."
  },
  "contentItems": {
    "title": "Éléments de contenu",
    "newItem": "Nouveau contenu",
    "createTitle": "Créer un élément de contenu",
    "upcoming": "À venir",
    "upcomingLabels": {
      "tomorrow": "Demain",
      "onePost": "1 publication",
      "postCount": "{count} publications",
      "emptyTitle": "Aucun contenu à venir",
      "emptyDescription": "Les publications planifiées apparaîtront ici."
    },
    "views": {
      "calendar": "Calendrier",
      "table": "Tableau"
    },
    "table": {
      "content": "Contenu",
      "status": "Statut",
      "channels": "Canaux",
      "revision": "Révision",
      "dueDate": "Échéance",
      "plannedDate": "Date prévue",
      "sortByContent": "Trier par contenu",
      "sortByStatus": "Trier par statut",
      "sortByChannels": "Trier par canaux",
      "sortByRevision": "Trier par révision",
      "sortByPlannedDate": "Trier par date prévue"
    },
    "loading": "Chargement des éléments de contenu...",
    "empty": "Aucun élément de contenu n'est disponible pour l'espace actif.",
    "noDueDate": "Aucune échéance",
    "assetsHelper": "Les ressources de la bibliotheque media sont maintenant liees depuis la page de detail de l'element apres sa creation.",
    "channelSetupRequired": {
      "title": "Configurez les canaux d'abord",
      "description": "Le contenu a besoin d'au moins un canal d'espace avant de pouvoir etre ciblé, prévisualisé ou planifié.",
      "action": "Configurer les canaux"
    },
    "calendar": {
      "organization": "Organisation",
      "workspace": "Espace",
      "mine": "Mes calendriers",
      "calendars": "Calendriers",
      "visibleCalendar": "{count} calendrier",
      "visibleCalendars": "{count} calendriers",
      "noCalendars": "Aucun calendrier disponible.",
      "addCalendar": "Ajouter un calendrier",
      "removeCalendar": "Supprimer le calendrier",
      "removeCalendarNamed": "Supprimer {name}",
      "removeConfirm": "Supprimer {name} des calendriers externes?",
      "alreadyAdded": "Déjà ajouté",
      "catalog": "Catalogue",
      "customIcs": "ICS personnalisé",
      "searchCatalog": "Rechercher des calendriers",
      "search": "Rechercher",
      "country": "Pays",
      "category": "Catégorie",
      "calendarName": "Nom du calendrier",
      "icsUrl": "URL ICS",
      "editColor": "Modifier la couleur du calendrier",
      "allDay": "Toute la journée",
      "context": "Contexte calendrier",
      "importedEvent": "Calendrier importé",
      "month": "Mois",
      "previousWeek": "Semaine précédente",
      "nextWeek": "Semaine suivante",
      "previousMonth": "Mois précédent",
      "nextMonth": "Mois suivant",
      "previousYear": "Année précédente",
      "nextYear": "Année suivante",
      "errors": {
        "required": "Le nom et l'URL du calendrier sont requis.",
        "duplicate": "Ce calendrier a déjà été ajouté.",
        "createFailed": "Le calendrier n'a pas pu être ajouté.",
        "deleteFailed": "Le calendrier n'a pas pu être supprimé."
      }
    },
    "dateContext": {
      "noEvents": "Aucun événement de calendrier visible pour cette date.",
      "viewDay": "Voir la journée"
    },
    "errors": {
      "required": "Le titre, la campagne, le message et les cibles sont requis.",
      "workspaceAccountRequired": "Cet espace a besoin d'un compte opérationnel avant de créer du contenu.",
      "createFailed": "L'élément de contenu n'a pas pu être créé."
    },
    "fields": {
      "title": "Titre",
      "client": "Client",
      "selectClient": "Sélectionner un client",
      "campaign": "Campagne",
      "selectCampaign": "Sélectionner une campagne",
      "dueDate": "Date d'échéance",
      "publicationTargets": "Cibles de publication",
      "publicationMessage": "Message de publication",
      "hashtags": "Hashtags",
      "hashtagsPlaceholder": "#lancement #marque #campagne",
      "assets": "Ressources"
    },
    "workflow": {
      "ariaLabel": "Workflow de contenu",
      "title": "Workflow",
      "loadingDetail": "Chargement du contenu...",
      "saveFirst": "Enregistrez le contenu pour voir les étapes du workflow.",
      "steps": {
        "intake": "Brief",
        "brainstorm": "Brainstorm / storyboard",
        "production": "Production",
        "content": "Contenu",
        "planning": "Planification",
        "publish": "Publier",
        "schedule": "Planification",
        "approval": "Approbation"
      },
      "states": {
        "skipped": "Ignoré",
        "notNeeded": "Non requis",
        "pending": "En attente",
        "draft": "Brouillon",
        "inApproval": "En approbation",
        "approved": "Approuvé",
        "scheduled": "Planifié",
        "published": "Publié",
        "inProduction": "En production",
        "requestChanges": "Changements demandés",
        "rejected": "Rejeté"
      },
      "meta": {
        "productionRequestsScoped": "{count} demande(s) de production cadrée(s)",
        "productionNeeded": "Travail de production requis",
        "productionNotNeeded": "Aucun travail de production requis",
        "intakeReady": "Brief prêt",
        "intakeDraft": "Titre requis",
        "channels": "{count} canal/canaux",
        "noDate": "Aucune date",
        "approvalDisabled": "L'approbation est désactivée pour cet espace.",
        "waitingOn": "En attente de {actor}",
        "decisionBy": "{decision} par {actor}",
        "stepsComplete": "{approved}/{total} étapes d'approbation terminées",
        "readyForApproval": "Prêt à demander l'approbation.",
        "noApprovalRequest": "Aucune demande d'approbation n'a encore été lancée."
      },
      "intake": {
        "title": "Brief de contenu",
        "heading": "Brief de contenu",
        "stepDescription": "Capturez le titre et le contexte optionnel avant de travailler le contenu des canaux.",
        "simple": "Contenu simple",
        "productionNeeded": "Production requise",
        "contentTitle": "Titre",
        "contentTitlePlaceholder": "Nommez ce contenu.",
        "clientRequirement": "Besoin client",
        "clientRequirementPlaceholder": "Capturez ce que le client a demandé, le contexte de l'appel et le problème que ce contenu doit résoudre.",
        "description": "Description",
        "descriptionPlaceholder": "Décrivez l'idée, le brief ou le plan visible par le client.",
        "ideation": "Idéation / remue-méninges",
        "ideationPlaceholder": "Idées brutes, angles, exemples, accroches ou pistes de campagne.",
        "vibe": "Ton",
        "vibePlaceholder": "Éducatif, premium, ludique, urgent...",
        "plannedPublishDate": "Date de publication prévue",
        "targetingHashtags": "Hashtags / ciblage",
        "targetingHashtagsPlaceholder": "#entrepriselocale #lancement #coulisses",
        "needsProduction": "Requiert du travail de production",
        "productionNotes": "Notes de portée production",
        "productionNotesPlaceholder": "Que faut-il produire, déléguer, filmer, monter, designer ou réviser?"
      },
      "brainstorm": {
        "title": "Brainstorm / storyboard",
        "heading": "Direction créative",
        "description": "Utilisez cette étape pour aligner la direction créative avant la production ou la rédaction.",
        "directionCaptured": "Direction créative capturée",
        "emptySummary": "Aucune note de direction",
        "creativeAngle": "Angle créatif / storyboard",
        "creativeAnglePlaceholder": "Accroches, idées de plans, références, séquences storyboard, direction visuelle et points clés.",
        "emptyTitle": "Léger pour le moment",
        "emptyDescription": "Les notes de storyboard sont enregistrées dans les champs d'idéation et de ton jusqu'à l'ajout d'une persistance dédiée."
      },
      "composition": {
        "heading": "Variantes par canal",
        "description": "Rédigez le texte publiable, choisissez les médias et prévisualisez chaque sortie de canal sélectionnée.",
        "brief": "Brief",
        "vibe": "Ton",
        "hashtags": "Hashtags",
        "targets": "Cibles",
        "copywriting": "Rédaction",
        "channelCustomizations": "{count} personnalisation(s) de canal",
        "noChannelsSelected": "Aucun canal sélectionné",
        "selectTarget": "Sélectionnez une cible",
        "hidePreview": "Masquer l'aperçu",
        "showPreview": "Afficher l'aperçu"
      },
      "schedule": {
        "title": "Planification",
        "heading": "Dates par canal",
        "description": "Sélectionnez les canaux de ce contenu et assignez une date à chaque canal.",
        "plannedFor": "Prévu pour {date}",
        "noPublishDate": "Aucune date de publication sélectionnée",
        "publishTiming": "Dates de publication",
        "scheduledCount": "{scheduled}/{total} planifiés",
        "datedCount": "{scheduled}/{total} datés",
        "empty": "Sélectionnez un ou plusieurs canaux avant d'assigner des dates.",
        "channels": "Canaux",
        "channelsHelp": "Choisissez les canaux configurés pour lesquels ce contenu est planifié.",
        "noConfiguredChannels": "Ajoutez des canaux à l'espace avant de planifier du contenu.",
        "targets": "Cibles",
        "targetsHelp": "Choisissez la date de publication de chaque cible.",
        "targetTimesAria": "Heures de publication des cibles",
        "targetDatesAria": "Dates de publication des cibles",
        "daySummaryAria": "Résumé du jour de publication",
        "unscheduledAria": "Placements cibles non planifiés",
        "stillNeedsTime": "Il manque une heure",
        "day": "Jour",
        "date": "Date",
        "time": "Heure",
        "hour": "Heure",
        "clear": "Effacer",
        "target": "Cible",
        "noPostsTimed": "Aucune publication prévue pour cette journée.",
        "readyToPublish": "Marquer prêt à publier"
      },
      "publish": {
        "title": "Publier",
        "description": "Confirmez les canaux et les dates de publication, puis créez la remise de publication planifiée.",
        "ready": "Prêt à publier",
        "scheduled": "Les publications sont planifiées.",
        "published": "Le contenu a été publié.",
        "action": "Publier",
        "unavailable": "Une approbation est requise avant de publier ce contenu."
      },
      "production": {
        "stageTitle": "Production",
        "stageHeading": "Prérequis de production",
        "stageDescription": "Planifiez le travail requis avant que ce contenu puisse être terminé.",
        "notRequiredTitle": "Aucun travail de production requis pour ce contenu.",
        "notRequiredDescription": "Ajoutez du travail de production si ce contenu requiert tournage, photos, design, montage, logistique ou livrables suivis.",
        "addWorkOrder": "Ajouter un bon de travail",
        "newRequest": "Nouveau bon de travail production",
        "newRequestMeta": "Tournage, design, montage, logistique ou livrables",
        "create": "Créer le bon de travail",
        "openRequests": "{open}/{total} bons de travail ouverts",
        "title": "Production ({type}) - {title}",
        "type": "Type",
        "priority": "Priorité",
        "dueDate": "Échéance",
        "assignee": "Responsable",
        "unassigned": "Non assigné",
        "requestTitle": "Titre",
        "brief": "Brief",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "edit": "Modifier",
        "addActiveMedia": "Ajouter le média actif",
        "priorityMeta": "Priorité : {priority}",
        "dueMeta": "Échéance : {due}",
        "commentsMeta": "Commentaires : {count}",
        "latestMeta": "Dernier : {latest}",
        "none": "Aucune",
        "noDeliverable": "Aucun livrable",
        "internalNote": "Note interne",
        "internalNotePlaceholder": "Ajouter une note de production interne...",
        "comment": "Commenter",
        "types": {
          "Copy": "Texte",
          "Image": "Image",
          "Video": "Vidéo",
          "Design": "Design",
          "Thumbnail": "Miniature",
          "Edit": "Montage",
          "Other": "Autre"
        },
        "priorities": {
          "Low": "Basse",
          "Normal": "Normale",
          "High": "Haute",
          "Urgent": "Urgente"
        },
        "statuses": {
          "Requested": "Demandé",
          "InProgress": "En cours",
          "InReview": "En révision",
          "ChangesRequested": "Changements demandés",
          "Accepted": "Accepté",
          "Cancelled": "Annulé"
        },
        "templates": {
          "video": "Tournage vidéo",
          "videoSummary": "Storyboard, lieu, talent, captation, montage",
          "photoshoot": "Séance photo",
          "photoshootSummary": "Liste de plans, photographe, lieu, accessoires, retouches",
          "design": "Asset design",
          "designSummary": "Brief créatif, mise en page, révision, export",
          "editing": "Montage / post-production",
          "editingSummary": "Séquences, premier montage, révisions, asset final",
          "custom": "Demande personnalisée",
          "customSummary": "Partir d'un brief de production vide"
        },
        "checklists": {
          "video": "Checklist:\n- Confirmer le brief créatif\n- Préparer le storyboard / la liste de plans\n- Réserver le lieu\n- Assigner le vidéaste\n- Confirmer les talents\n- Préparer l'équipement\n- Capturer les séquences\n- Monter la première version\n- Téléverser l'asset final\n- Approbation production",
          "photoshoot": "Checklist:\n- Confirmer la liste de plans\n- Réserver le photographe\n- Réserver le lieu\n- Préparer les produits / accessoires\n- Faire la séance photo\n- Sélectionner les photos finales\n- Retoucher\n- Téléverser les assets finaux\n- Approbation production",
          "design": "Checklist:\n- Confirmer le brief créatif\n- Rassembler les assets de marque\n- Créer le premier design\n- Révision interne\n- Appliquer les révisions\n- Exporter l'asset final\n- Téléverser l'asset final\n- Approbation production",
          "editing": "Checklist:\n- Rassembler les séquences source\n- Créer le premier montage\n- Ajouter sous-titres / graphiques\n- Révision interne\n- Appliquer les révisions\n- Exporter la version finale\n- Téléverser l'asset final\n- Approbation production"
        }
      },
      "gates": {
        "label": "Porte d'approbation",
        "noApprover": "Configuration d'approbateur indisponible pour le moment",
        "stepsComplete": "{approved}/{total} étapes terminées",
        "noApprovals": "Aucune approbation requise",
        "pendingCount": "{count} porte(s) d'approbation demandent attention",
        "ready": "Portes d'approbation claires",
        "noApprovalRequired": "Aucune approbation requise pour cette étape.",
        "awaitingDecision": "En attente de décision.",
        "approved": "Approuvé.",
        "needsFollowUp": "Suivi requis.",
        "optionalAction": "L'approbation est optionnelle pour cette étape.",
        "requiredAction": "L'approbation est requise avant que cette étape soit claire.",
        "modes": {
          "none": "Aucune",
          "optional": "Optionnelle",
          "required": "Requise",
          "multiStep": "Multi-étapes"
        },
        "status": {
          "notRequired": "Non requise",
          "notRequested": "Non demandée",
          "pending": "En attente",
          "approved": "Approuvée",
          "rejected": "Rejetée",
          "changesRequested": "Changements demandés"
        }
      },
      "readiness": {
        "title": "Préparation",
        "subtitle": "Ce qui bloque l'avancement du contenu.",
        "blockers": "Blocages",
        "blockersCount": "{count} blocage(s)",
        "brief": "Brief",
        "briefReady": "Brief capturé",
        "briefMissing": "Le brief est manquant",
        "titleMissing": "Le titre est manquant",
        "clientRequirementMissing": "Le besoin client est manquant",
        "productionMissing": "La production est requise, mais aucun bon de travail n'existe.",
        "productionOpen": "{title} n'est pas encore accepté.",
        "productionAssigneeMissing": "{title} n'a pas de responsable.",
        "productionDueMissing": "{title} n'a pas d'échéance.",
        "deliverableMissing": "{title} n'a pas de livrable.",
        "productionReady": "Les prérequis de production sont clairs",
        "noChannels": "Aucun canal sélectionné",
        "missingTimeFor": "Il manque une date de publication pour {target}."
      },
      "approval": {
        "request": "Demander l'approbation",
        "decisionAria": "Décision d'approbation",
        "workflowAria": "Workflow d'approbation",
        "title": "Approbation",
        "unavailable": "Indisponible",
        "waitingOnYou": "En attente de vous",
        "waitingOnApprover": "En attente de l'approbateur",
        "saveFirst": "Enregistrez le contenu avant de demander l'approbation.",
        "modeNone": "Cet espace ne requiert pas d'approbation.",
        "reviewer": "Réviseur",
        "approver": "Approbateur",
        "step": "Étape {number}",
        "reason": "Raison",
        "reasonPlaceholder": "Ajoutez la note d'approbation, la raison du rejet ou les changements demandés.",
        "approve": "Approuver",
        "changes": "Changements",
        "reject": "Rejeter",
        "decisionFailed": "La décision d'approbation n'a pas pu être enregistrée.",
        "workflow": "Workflow",
        "status": "Statut",
        "due": "Échéance",
        "action": "Action",
        "noDueDate": "Aucune échéance",
        "directReviewer": "Réviseur direct",
        "noAction": "Aucune action disponible",
        "clickToApprove": "Cliquez sur le cercle pour approuver.",
        "productionTitle": "Production",
        "publicationTitle": "Publication",
        "publishedTitle": "Publié",
        "approvalEmpty": "Passez ce contenu en approbation pour lancer les étapes configurées.",
        "noApprovalActivity": "Aucune activité d'approbation pour le moment."
      },
      "collaboration": {
        "title": "Collaboration",
        "empty": "Enregistrez le contenu pour lancer les commentaires, l'activité et l'historique.",
        "noActivity": "Aucune activité n'a encore été enregistrée.",
        "noHistory": "Aucun changement de champ n'a encore été enregistré.",
        "to": "vers"
      },
      "smartEditor": {
        "bold": "Gras",
        "italic": "Italique",
        "mention": "Mention",
        "hashtag": "Hashtag",
        "emoji": "Emoji",
        "noMatchingMembers": "Aucun membre correspondant",
        "createHashtag": "Créer #{tag}",
        "newHashtag": "Nouveau hashtag",
        "searchEmojis": "Rechercher des emojis"
      }
    }
  },
  "userSettings": {
    "eyebrow": "Informations utilisateur",
    "title": "Profil et identité",
    "description": "Gérez le portrait et les informations du compte affichés dans l'espace.",
    "tabs": {
      "information": "Informations",
      "notifications": "Notifications",
      "calendars": "Calendriers"
    },
    "updatePortrait": "Mettre à jour le portrait",
    "accountDetails": "Détails du compte",
    "accountDetailsDescription": "Modifiez les informations de profil visibles par les autres membres.",
    "saveDetails": "Enregistrer les détails",
    "saved": "Informations de profil enregistrées",
    "emailConfirmationSent": "Informations de profil enregistrées. Consultez votre nouvelle adresse email pour confirmer le changement.",
    "portraitSaved": "Portrait enregistré",
    "calendarFeed": {
      "title": "Flux calendrier privé",
      "description": "Abonnez vos apps calendrier externes à vos dates de travail Socialize.",
      "empty": "Le flux calendrier privé est désactivé.",
      "feedUrl": "URL d'abonnement",
      "enable": "Activer le flux",
      "copy": "Copier l'URL",
      "regenerate": "Régénérer l'URL",
      "revoke": "Révoquer le flux",
      "enabled": "Flux calendrier activé",
      "regenerated": "URL du flux calendrier régénérée",
      "revoked": "Flux calendrier révoqué",
      "copied": "URL du flux calendrier copiée",
      "errors": {
        "copyFailed": "L'URL n'a pas pu être copiée.",
        "updateFailed": "Le flux calendrier n'a pas pu être mis à jour."
      }
    },
    "notifications": {
      "title": "Méthodes de notification",
      "description": "Choisissez comment les notifications de workflow vous rejoignent.",
      "loading": "Chargement des préférences de notification...",
      "saved": "Préférence de notification enregistrée",
      "webPushTitle": "Push navigateur",
      "webPushStatus": "Permission : {status}",
      "enableWebPush": "Activer le push navigateur",
      "webPushEnabled": "Push navigateur activé",
      "channels": {
        "InApp": "Dans l'app",
        "Email": "Email",
        "Sms": "SMS",
        "WebPush": "Push navigateur",
        "NativePush": "Push téléphone"
      },
      "errors": {
        "loadFailed": "Les préférences de notification n'ont pas pu être chargées.",
        "saveFailed": "La préférence de notification n'a pas pu être enregistrée.",
        "webPushUnsupported": "Le push navigateur n'est pas disponible dans ce navigateur ou cet environnement.",
        "permissionDenied": "La permission push navigateur n'a pas été accordée.",
        "webPushFailed": "Le push navigateur n'a pas pu être activé."
      }
    },
    "alias": "Alias",
    "firstname": "Prénom",
    "lastname": "Nom",
    "fullName": "Nom complet",
    "email": "Email",
    "preferredLanguage": "Langue préférée",
    "noEmail": "Aucun email défini",
    "cropperTitle": "Mettre à jour le portrait utilisateur",
    "savePortrait": "Enregistrer le portrait",
    "choosePortrait": "Choisir un portrait",
    "errors": {
      "emailRequired": "L'email est requis.",
      "saveFailed": "Les informations de profil n'ont pas pu être enregistrées.",
      "portraitFailed": "Le portrait n'a pas pu être enregistré."
    }
  },
  "workspaceSettings": {
    "eyebrow": "Paramètres",
    "title": "Paramètres de l'espace",
    "description": "Configurez l'espace courant avec les sections general, membres, workflow et canaux sociaux.",
    "currentWorkspace": "Espace actuel",
    "noWorkspaceSelected": "Aucun espace sélectionné",
    "activeWorkspace": "Espace actif",
    "contextNote": "Ces paramètres s'appliquent uniquement à l'espace courant.",
    "inviteTitle": "Inviter des membres",
    "inviteDescription": "Invitez des clients, sous-traitants ou collègues dans l'espace actif.",
    "inviteEmpty": "Aucune invitation en attente pour cet espace.",
    "sendInvite": "Inviter",
    "reset": "Réinitialiser",
    "errors": {
      "required": "Tous les champs de l'espace sont requis.",
      "createFailed": "L'espace n'a pas pu être créé.",
      "updateFailed": "Les paramètres de l'espace n'ont pas pu être enregistrés.",
      "deleteFailed": "L'espace n'a pas pu être supprimé.",
      "logoUploadFailed": "Le logo de l'espace n'a pas pu être enregistré.",
      "inviteRequired": "L'email et le rôle sont requis pour inviter un membre.",
      "emailRequired": "Entrez une adresse email.",
      "emailInvalid": "Entrez une adresse email valide.",
      "inviteFailed": "L'invitation de l'espace n'a pas pu être créée.",
      "memberRemoveFailed": "Le membre de l'espace n'a pas pu être retiré."
    },
    "fields": {
      "name": "Nom de l'espace",
      "slug": "Slug de l'espace",
      "slugHint": "Utilise comme nom de dossier sous la racine DAM de l'organisation.",
      "timeZone": "Fuseau horaire",
      "memberEmail": "Email du membre",
      "memberRole": "Rôle"
    },
    "roles": {
      "administrator": "Administrateur",
      "manager": "Gestionnaire",
      "client": "Réviseur client",
      "provider": "Sous-traitant",
      "workspace-member": "Membre de l'espace"
    },
    "summary": {
      "name": "Nom",
      "timeZone": "Fuseau horaire"
    },
    "delete": {
      "kicker": "Zone dangereuse",
      "title": "Supprimer l'espace",
      "description": "Supprimez definitivement cet espace ainsi que son contenu, ses medias, messages, approbations, canaux, membres et donnees de workflow liees.",
      "confirmationLabel": "Tapez {name} pour confirmer",
      "confirmationMismatch": "Tapez exactement le nom de l'espace pour le supprimer.",
      "action": "Supprimer l'espace",
      "deleting": "Suppression de l'espace"
    },
    "tabs": {
      "general": "Général",
      "members": "Membres",
      "workflow": "Workflow",
      "channels": "Canaux"
    },
    "members": {
      "inviteTitle": "Inviter",
      "activeTitle": "Membres",
      "activeDescription": "Voyez toutes les personnes qui appartiennent actuellement à l'espace actif.",
      "activeEmpty": "Aucun membre trouvé pour cet espace.",
      "pendingTitle": "Invitations en attente",
      "pendingDescription": "Suivez les personnes invitées dans l'espace actif.",
      "resendInvite": "Renvoyer l'email",
      "cancelInvite": "Annuler l'invitation",
      "editPermissions": "Modifier les permissions",
      "editRole": "Modifier le role",
      "removeAction": "Retirer le membre",
      "removeConfirm": "Retirer {name} de cet espace ?",
      "removed": "Membre de l'espace retiré."
    },
    "channels": {
      "title": "Acces aux canaux sociaux",
      "description": "Consultez les connexions fournisseur, l'etat OAuth, les controles de jeton et les permissions manquantes des canaux de l'espace.",
      "addChannel": "Ajouter un canal",
      "empty": "Aucun canal d'espace n'a encore ete configure.",
      "notConnected": "Non connecte",
      "connectedAccount": "compte connecte",
      "accountName": "Nom du compte",
      "platform": "Plateforme",
      "status": "Statut",
      "actions": "Actions",
      "destinationRequired": "Choisissez une destination fournisseur pour creer le canal de l'espace.",
      "chooseDestination": "Choisir le canal",
      "providerDestination": "Destination fournisseur",
      "tokenExpiry": "Expiration du jeton",
      "noExpiry": "Sans expiration",
      "expiresInDays": "Expire dans {days} jours",
      "expiredDaysAgo": "Expire depuis {days} jours",
      "lastCheck": "Dernier controle",
      "notChecked": "Non controle",
      "permissionDetails": "Details des permissions",
      "grantedScopes": "Permissions accordees",
      "missingScopes": "Permissions manquantes",
      "none": "Aucune",
      "connectedAccountFallback": "Compte YouTube",
      "providerAccountFallback": "Compte {provider}",
      "connect": "Connecter",
      "unavailable": "Indisponible",
      "configuredCount": "{count} configuré(s)",
      "refresh": "Actualiser",
      "reconnect": "Reconnecter",
      "verify": "Verifier",
      "disconnect": "Deconnecter",
      "removeAccount": "Déconnecter la connexion",
      "changeName": "Changer le nom",
      "changeNameDescription": "Mettez a jour le nom affiche pour ce canal de l'espace.",
      "nameRequired": "Un nom de canal est requis.",
      "renameFailed": "Le nom du canal n'a pas pu etre modifie.",
      "deleteChannelFailed": "Le canal n'a pas pu etre supprime.",
      "providerBrowser": {
        "kicker": "Configuration des canaux",
        "title": "Ajouter un canal",
        "description": "Choisissez un réseau social, connectez le compte, puis sélectionnez la destination pour cet espace.",
        "comingSoon": "Bientôt disponible",
        "oauthNotConfigured": "OAuth non configuré"
      },
      "destinations": {
        "title": "Choisir la destination à ajouter",
        "description": "Sélectionnez la destination pour laquelle cet espace planifiera, révisera et programmera du contenu.",
        "connectedAccount": "Compte connecté",
        "connected": "Deja connecte",
        "usingAccount": "Compte utilisé : {account}",
        "destination": "Destination",
        "empty": "Aucune destination n'a ete retournee pour ce compte. Verifiez les permissions du fournisseur, puis reconnectez le compte.",
        "loadFailed": "Les destinations du fournisseur n'ont pas pu etre chargees. Verifiez les permissions du fournisseur, puis reconnectez le compte.",
        "connectFailed": "La destination selectionnee n'a pas pu etre connectee.",
        "selectedCount": "{count} sélectionné(s)",
        "confirm": "Confirmer"
      },
      "providerCategories": {
        "all": "Tous",
        "social": "Social",
        "videos": "Vidéos",
        "reviews": "Avis",
        "business": "Entreprise",
        "analytics": "Analytiques",
        "community": "Communauté",
        "other": "Autre"
      },
      "health": {
        "NotConnected": "Non connecte",
        "Connected": "Connecte",
        "MissingPermissions": "Permissions manquantes",
        "TokenExpired": "Jeton expire",
        "ProviderUnavailable": "Fournisseur indisponible",
        "Disconnected": "Deconnecte",
        "ActionRequired": "Action requise"
      }
    },
    "general": {
      "detailsTitle": "Détails de l'espace",
      "detailsDescription": "Mettez à jour le nom de l'espace et le fuseau horaire par défaut utilisés dans les calendriers et les vues de l'espace.",
      "saveAction": "Enregistrer l'espace",
      "saved": "Paramètres de l'espace enregistrés."
    },
    "logo": {
      "title": "Logo de l'espace",
      "description": "Utilisez un fichier local ou une image distante, puis recadrez-la pour l'espace.",
      "changeAction": "Changer l'image",
      "cropperTitle": "Mettre à jour le logo de l'espace",
      "saveAction": "Enregistrer le logo",
      "chooseAction": "Choisir un logo",
      "saved": "Logo de l'espace enregistré."
    },
    "approvals": {
      "flowTitle": "Flux d'approbation",
      "flowDescription": "Configurez le fonctionnement de l'approbation du contenu dans cet espace.",
      "previewTitle": "Aperçu du flux",
      "previewDescription": "Voici la séquence que l'espace utilisera selon la configuration actuelle.",
      "saved": "Flux d'approbation enregistré.",
      "saveAction": "Enregistrer le flux",
      "fields": {
        "approvalMode": "Mode d'approbation",
        "schedulePostsAutomaticallyOnApproval": "Planifier automatiquement après approbation",
        "lockContentAfterApproval": "Verrouiller le contenu après approbation",
        "sendAutomaticApprovalReminders": "Envoyer des rappels automatiques"
      },
      "fieldHelp": {
        "schedulePostsAutomaticallyOnApproval": "L'approbation finale passe le contenu à Planifié quand une date de publication est déjà prévue.",
        "lockContentAfterApproval": "Le contenu contrôlé par l'approbation est verrouillé après l'approbation finale. Les champs de planification restent modifiables.",
        "sendAutomaticApprovalReminders": "Les approbateurs courants reçoivent des rappels quotidiens tant qu'une étape est en attente."
      },
      "modes": {
        "none": "Aucun",
        "optional": "Optionnel",
        "required": "Requis",
        "multiLevel": "Multi-niveaux"
      },
      "modeHelp": {
        "none": "Le contenu saute le workflow d'approbation et peut devenir Approuvé sans action d'approbation.",
        "optional": "Un workflow d'approbation en une étape est disponible, mais il ne bloque pas la publication.",
        "required": "Au moins une approbation est requise avant que le contenu devienne Approuvé ou Planifié.",
        "multiLevel": "L'approbation utilise des étapes ordonnées avec des approbateurs ciblés pour chaque étape."
      },
      "editor": {
        "title": "Étapes multi-niveaux",
        "description": "Définissez qui approuve chaque étape ordonnée avant l'approbation finale du contenu.",
        "addStep": "Ajouter une étape",
        "empty": "Ajoutez au moins une étape d'approbation avant d'enregistrer le mode multi-niveaux.",
        "unnamedStep": "Étape sans nom",
        "moveUp": "Monter l'étape",
        "moveDown": "Descendre l'étape",
        "removeStep": "Supprimer l'étape",
        "selectMember": "Sélectionner un membre",
        "selectMembers": "Sélectionnez un ou plusieurs membres. Maintenez Ctrl ou Commande pour une sélection multiple.",
        "defaultStepName": "Étape d'approbation {number}",
        "stepNumber": "Étape {number}",
        "fields": {
          "name": "Nom affiché",
          "targetType": "Type de cible",
          "targetValue": "Cible",
          "requiredApproverCount": "Approbateurs requis"
        },
        "targetTypes": {
          "role": "Rôle",
          "membership": "Appartenance",
          "member": "Membre"
        },
        "memberships": {
          "team": "Équipe",
          "client": "Client"
        },
        "errors": {
          "atLeastOneStep": "L'approbation multi-niveaux requiert au moins une étape.",
          "fixInvalidSteps": "Corrigez les étapes d'approbation indiquées avant d'enregistrer.",
          "nameRequired": "Saisissez un nom d'étape.",
          "targetRequired": "Choisissez qui peut approuver cette étape.",
          "notEnoughMembers": "Sélectionnez au moins autant de membres que d'approbateurs requis.",
          "requiredApproverCount": "Saisissez au moins 1 approbateur requis."
        }
      },
      "steps": {
        "none": "Approbation ignorée",
        "approval": "Approbation",
        "publish": "Passage à la publication"
      },
      "stepDetail": {
        "none": "Aucun workflow d'approbation n'est créé pour le contenu de cet espace.",
        "optional": "L'approbation peut être recueillie, mais elle n'est pas requise avant la publication.",
        "approverCount": "{count} approbateur(s) requis",
        "multiLevelTarget": "{count} approbateur(s) de {target}",
        "autoSchedule": "Le contenu approuvé avec une date de publication prévue passe à Planifié.",
        "manualSchedule": "Le contenu approuvé reste Approuvé jusqu'à sa planification."
      }
    }
  },
  "mediaLibrary": {
    "eyebrow": "Bibliotheque media",
    "title": "Medias de l'espace",
    "loading": "Chargement de la bibliotheque media...",
    "uploadFile": "Fichier media",
    "upload": "Uploader",
    "folderName": "Nom du dossier",
    "createFolder": "Creer un dossier",
    "folder": "Dossier",
    "download": "Telecharger",
    "rename": "Renommer",
    "renameLabel": "Nouveau nom",
    "linked": "Lie",
    "unlinked": "Non lie",
    "emptyAssets": "Aucun fichier media.",
    "storage": {
      "used": "Espace utilise",
      "available": "Disponible sur le plan",
      "notMetered": "Non mesure",
      "sizeUnavailable": "Taille indisponible",
      "currentPlan": "Plan actuel",
      "limit": "Limite du plan : {limit}"
    },
    "metrics": {
      "files": "Fichiers",
      "linkedSummary": "{linked} lies / {unlinked} non lies"
    },
    "list": {
      "title": "Bibliotheque",
      "count": "{count} elements"
    },
    "details": {
      "linkState": "Etat du lien",
      "size": "Taille",
      "updated": "Mis a jour",
      "unavailable": "Indisponible"
    }
  },
  "errors": {
    "unexpected": "Une erreur inattendue s'est produite",
    "imageLoad": "Erreur lors du chargement de l'image",
    "imageUpload": "Erreur lors du téléchargement de l'image"
  }
}
